(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["porao-cart-drawer"]) return;
  try {
    

  /* MOVIDO DO INLINE (27/07): rodava em <script> no corpo e inflava o HTML de toda pagina.
     Aqui compila pro scripts.js (cacheado, deferred). IIFE com guard proprio. */
(function(){
  if (window.__pcdWired) return;
  window.__pcdWired = true;

  var SEC = 'porao-cart-drawer';
  var q = function(s, r){ return (r||document).querySelector(s); };

  function drawer(){ return q('[data-pcd]'); }
  function overlay(){ return q('[data-pcd-overlay]'); }

  /* ===== Prazo de entrega na gaveta (31/07) =====
     18/20 abandonos descobriam o prazo só no checkout, com o endereço já digitado.
     MESMA chave (pdq_cep), MESMA tabela ZONES e MESMAS regras (produção 2du, corte 17h)
     do porao-cart.liquid — se mudar lá, mudar aqui. Delegação no document: sobrevive
     a re-render da gaveta. */
  var PZ_ZONES = [
    [1000,19999,3],[20000,28999,5],[29000,29999,5],[30000,39999,5],
    [40000,48999,10],[49000,49999,10],[50000,56999,10],[57000,57999,10],
    [58000,58999,10],[59000,59999,10],[60000,63999,10],[64000,64999,10],
    [65000,65999,10],[66000,68899,10],[68900,68999,15],[69000,69299,15],
    [69300,69399,15],[69400,69899,15],[69900,69999,18],[70000,72799,8],
    [72800,72999,10],[73000,73699,8],[73700,76799,10],[76800,76999,18],
    [77000,77999,18],[78000,78899,13],[78900,78999,18],[79000,79999,13],
    [80000,87999,5],[88000,89999,5],[90000,99999,5]
  ];
  var PZ_DIAS = ['domingo','segunda','terça','quarta','quinta','sexta','sábado'];
  var PZ_MESES = ['jan.','fev.','mar.','abr.','maio','jun.','jul.','ago.','set.','out.','nov.','dez.'];
  /* bugfix 28/08: feriado nacional não é dia útil — nem de produção nem de transporte */
  var FERIADOS_BR = ['2026-01-01','2026-02-16','2026-02-17','2026-04-03','2026-04-21','2026-05-01','2026-06-04','2026-09-07','2026-10-12','2026-11-02','2026-11-15','2026-11-20','2026-12-25','2027-01-01','2027-02-08','2027-02-09','2027-03-26','2027-04-21','2027-05-01','2027-05-27','2027-09-07','2027-10-12','2027-11-02','2027-11-15','2027-11-20','2027-12-25'];
  function ehFeriado(d){ var m = d.getMonth()+1, dd = d.getDate(); return FERIADOS_BR.indexOf(d.getFullYear() + '-' + (m<10?'0':'') + m + '-' + (dd<10?'0':'') + dd) !== -1; }
  function pzNow(){ var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset()*60000 - 3*3600000); }
  function pzAddBiz(date, days){ var d = new Date(date), a = 0; while (a < days){ d.setDate(d.getDate()+1); var w = d.getDay(); if (w >= 1 && w <= 5 && !ehFeriado(d)) a++; } return d; }
  function pzTransit(cep){ var n = parseInt(cep.slice(0,5),10); for (var i=0;i<PZ_ZONES.length;i++){ if (n>=PZ_ZONES[i][0] && n<=PZ_ZONES[i][1]) return PZ_ZONES[i][2]; } return null; }
  function pzCepSalvo(){ try{ var c = (localStorage.getItem('pdq_cep')||'').replace(/\D/g,''); return c.length===8 ? c : null; }catch(_){ return null; } }
  function atualizaPrazo(destacar){
    var alvo = document.querySelector('[data-pcd-frete]');
    var tog  = document.querySelector('[data-pcd-cep-toggle]');
    if(!alvo) return;
    /* pisca a faixa quando a data acabou de ser calculada: se o CEP novo dá a MESMA data,
       nada mudava na tela e parecia travado (Will 31/07) */
    if (destacar){
      var faixa = alvo.closest('.pcd__reassure');
      if (faixa){ faixa.classList.remove('is-novo');
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ faixa.classList.add('is-novo'); }); }); }
    }
    var cep = pzCepSalvo();
    var transit = cep ? pzTransit(cep) : null;
    if (transit != null){
      var now = pzNow();
      var beforeCut = (now.getDay()>=1 && now.getDay()<=5 && !ehFeriado(now) && now.getHours()<17);
      var ini = beforeCut ? now : pzAddBiz(now,1);
      var d = pzAddBiz(ini, 2 + transit);
      alvo.innerHTML = 'Frete grátis · chega até <strong>' + PZ_DIAS[d.getDay()] + ', ' + d.getDate() + ' de ' + PZ_MESES[d.getMonth()] + '</strong>';
      if (tog) tog.textContent = 'alterar';
    } else {
      alvo.textContent = 'Frete grátis para todo o Brasil';
      if (tog) tog.textContent = 'calcular chegada';
    }
  }
  function calculaCepGaveta(){
    var inp = document.querySelector('[data-pcd-cep-input]');
    var btn = document.querySelector('[data-pcd-cep-ok]');
    if(!inp) return;
    var cep = (inp.value||'').replace(/\D/g,'');
    if (cep.length !== 8 || pzTransit(cep) == null){
      inp.value=''; inp.placeholder='CEP inválido'; inp.classList.add('is-err'); inp.focus(); return;
    }
    inp.classList.remove('is-err');
    try{ localStorage.setItem('pdq_cep', cep); }catch(_){}
    /* "calculando…" por meio segundo: a conta é instantânea, mas sem esse respiro o clique
       não devolve NADA visível quando a data repete (Will 31/07) */
    if (btn){ btn.disabled = true; btn.textContent = 'calculando…'; }
    setTimeout(function(){
      var box = document.querySelector('[data-pcd-cep]'); if(box) box.hidden = true;
      if (btn){ btn.disabled = false; btn.textContent = 'Ver data'; }
      atualizaPrazo(true);
      try{ if(typeof gtag==='function') gtag('event','pdp_calcula_cep',{ prazo_dias: 2 + pzTransit(cep), origem:'gaveta' }); }catch(_){}
    }, 450);
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest && t.closest('[data-pcd-cep-toggle]')){
      var box = document.querySelector('[data-pcd-cep]');
      if (box){ box.hidden = !box.hidden;
        if(!box.hidden){
          var i = document.querySelector('[data-pcd-cep-input]');
          if(i){
            /* já vem com o CEP salvo escrito: ninguém deve redigitar o que o site já sabe */
            var s = pzCepSalvo();
            if (s && !i.value) i.value = s.slice(0,5) + '-' + s.slice(5);
            try{ i.focus(); i.select(); }catch(_){}
          }
        }
      }
      return;
    }
    if (t.closest && t.closest('[data-pcd-cep-ok]')){ calculaCepGaveta(); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-pcd-cep-input')){
      e.preventDefault(); calculaCepGaveta();
    }
  });

  function abrir(){
    var d = drawer(), o = overlay();
    if(!d) return;
    /* medição (30/07): gaveta não gera pageview — sem este evento, "ver o carrinho" era invisível no GA4 */
    try{ if(typeof gtag==='function') gtag('event','view_cart',{metodo:'gaveta'}); }catch(_){}
    atualizaPrazo();
    if(o) o.hidden = false;
    d.hidden = false;
    /* força reflow pra transição rodar a partir do estado fechado */
    void d.offsetWidth;
    document.documentElement.classList.add('pcd-open');
    document.documentElement.style.overflow = 'hidden';
    var x = q('[data-pcd-close]', d); if(x) try{ x.focus({preventScroll:true}); }catch(_){}
  }
  function fechar(){
    var d = drawer(), o = overlay();
    document.documentElement.classList.remove('pcd-open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){
      if(d && !document.documentElement.classList.contains('pcd-open')) d.hidden = true;
      if(o && !document.documentElement.classList.contains('pcd-open')) o.hidden = true;
    }, 300);
  }

  /* bugfix 28/08: busy() virou SÓ feedback visual. O b.disabled era INERTE — os +/- da
     página são <a> desde 08/08 e âncora ignora a propriedade disabled — e, se bloqueasse
     de verdade, engoliria toques. Quem impede o race agora é a fila de intenção em
     mudar(): uma requisição em voo por linha + debounce + "última intenção vence". */
  function busy(on){
    var d = drawer(); if(d) d.classList.toggle('is-busy', !!on);
    document.querySelectorAll('.porao-cart__qty-btn').forEach(function(b){
      b.style.opacity = on ? '.45' : '';
    });
  }

  function contadores(c){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = c.item_count > 9 ? '9+' : String(c.item_count);
      el.hidden = c.item_count === 0;
    });
  }

  /* Re-renderiza o drawer pelo Section Rendering API (HTML do servidor = preços/moeda corretos) */
  var refreshSeq = 0; /* bugfix 28/08: nº de sequência — resposta ATRASADA (buscada antes da última mudança) não sobrescreve a nova */
  function refresh(){
    var meu = ++refreshSeq;
    return fetch('/?sections=' + SEC, {headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (meu !== refreshSeq) return;
        var html = j[SEC];
        if(!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('[data-pcd-content]');
        var atual = q('[data-pcd-content]');
        if(novo && atual) atual.innerHTML = novo.innerHTML;
      })
      .then(function(){ return fetch('/cart.js', {headers:{'Accept':'application/json'} }).then(function(r){ return r.json(); }); })
      .then(function(c){ if (meu !== refreshSeq) return c; contadores(c); atualizaPrazo(); return c; })
      .catch(function(){});
  }

  /* 16/10: a troca de moldura/tamanho da prévia do desktop redesenha a gaveta por aqui */
  window.PoraoCartDrawer = { refresh: refresh, abrir: abrir };

  /* Se estiver NA página do carrinho, re-renderiza a seção dela também (sem reload).
     ⚠️ O id NÃO é 'main'. Em template JSON (cart.json) a Shopify nomeia a seção
     'template--<id>__main', e tanto o ?sections= quanto o querySelector precisam do id REAL.
     Com 'main' fixo a API devolvia {"main":null}, o guard engolia em silêncio e a página
     ficava com o total ANTIGO enquanto o servidor já cobrava o novo — o cliente via
     R$ 1.062 na tela e R$ 2.125 no checkout (medido em 21/07). */
  function idSecaoCarrinho(){
    var el = document.querySelector('[id^="shopify-section-"][id$="__main"]')
          || document.querySelector('#shopify-section-main');
    return el ? el.id.replace('shopify-section-', '') : null;
  }
  var refreshPagSeq = 0; /* bugfix 28/08: nº de sequência — o innerHTML de um refresh atrasado (buscado ANTES da última mudança) vencia o novo e a tela divergia do servidor */
  function refreshPaginaCarrinho(){
    if (!/\/cart\b/.test(location.pathname)) return Promise.resolve();
    var sec = idSecaoCarrinho();
    if(!sec) return Promise.resolve();
    var meu = ++refreshPagSeq;
    /* ⚠️ 'Accept: text/html' EXPLÍCITO — não é enfeite e não pode virar application/json.
       Em /cart, o Accept:application/json faz a Shopify responder como /cart.js (token,
       items, total_price…) e IGNORAR o ?sections=. Só omitir o cabeçalho não basta: há
       app de terceiro na loja que embrulha o window.fetch e o Accept chegava como
       application/json mesmo sem a gente pedir (verificado no painel de rede em 21/07).
       Declarando text/html, a resposta é sempre a da Section Rendering: { "<id>": "<html>" }. */
    return fetch('/cart?sections=' + encodeURIComponent(sec), {headers:{'Accept':'text/html'} })
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (meu !== refreshPagSeq) return;
        var html = j[sec]; if(!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('#shopify-section-' + sec) || doc.body.firstElementChild;
        var atual = document.querySelector('#shopify-section-' + sec);
        if(novo && atual){
          atual.innerHTML = novo.innerHTML;
          /* bugfix 28/08: innerHTML NÃO re-executa <script> — avisa a calculadora de CEP
             inline (porao-cart.liquid) pra repintar o estado salvo nos nós novos */
          document.dispatchEvent(new CustomEvent('porao:cart-refresh'));
        }
      })
      .catch(function(){});
  }

  /* bugfix 28/08 (race dos +/-): "ÚLTIMA INTENÇÃO VENCE", sem engolir toques. Cada clique
     atualiza a UI na hora e só REGISTRA a intenção; um debounce de 350ms despacha UMA
     requisição em voo por linha, com nº de sequência (resposta de sequência antiga é
     descartada). Se a intenção mudou enquanto voava, envia de novo ANTES de re-renderizar.
     Antes, cada clique era um POST com quantidade ABSOLUTA e respostas fora de ordem
     regrediam a quantidade (sonda 28/08: 7 POSTs paralelos terminando em 5 quando o
     cliente parou em 4; no mobile, taps eram simplesmente perdidos). */
  var filaQty = {};
  function despacha(key){
    var f = filaQty[key];
    if (!f || f.emVoo) return;
    f.emVoo = true;
    var qty = f.want;
    var meuSeq = ++f.seq;
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    })
    /* Checar r.ok: um 422 (limite de estoque) vinha como JSON normal e era ignorado —
       a pessoa clicava e não acontecia nada, sem nenhuma explicação. */
    .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
    .then(function(){
      f.emVoo = false;
      if (meuSeq !== f.seq) return; /* resposta de sequência antiga — descarta */
      if (f.want !== qty){ despacha(key); return; } /* intenção mudou no voo — manda a nova antes de re-renderizar */
      return Promise.all([refresh(), refreshPaginaCarrinho()]).then(function(){
        if (!f.timer && !f.emVoo && f.want === qty) busy(false);
      });
    })
    .catch(function(err){
      f.emVoo = false;
      var msg = err && (err.description || err.message);
      if (msg && window.PoraoToast) window.PoraoToast(msg);
      if (f.want !== qty){ despacha(key); return; }
      /* Ressincroniza a tela com o servidor mesmo no erro: melhor mostrar o estado real
         do que deixar a pessoa achando que mudou algo que não mudou. */
      return Promise.all([refresh(), refreshPaginaCarrinho()]).then(function(){ busy(false); }).catch(function(){ busy(false); });
    });
  }
  function mudar(key, qty){
    var f = filaQty[key] || (filaQty[key] = { want:0, timer:null, emVoo:false, seq:0 });
    f.want = qty;
    busy(true);
    if (f.timer) clearTimeout(f.timer);
    f.timer = setTimeout(function(){ f.timer = null; despacha(key); }, 350);
  }

  /* 04/10 (Will: "corrija o defeito"): o toque em COMPRAR ficava 1,6–5 s SEM resposta no celular e
     um 2º toque mandava um 2º /cart/add.js — o cliente chegava ao carrinho com 2 quadros e o preço
     dobrado. Agora: (1) TRAVA — uma adição por vez na página inteira; (2) o botão mostra
     "Adicionando…" na hora; (3) depois do /cart/add.js vai DIRETO pro /cart — o refresh() buscava a
     gaveta (/?sections=porao-cart-drawer) e o /cart.js, duas idas ao servidor em série que não
     serviam pra nada desde que a gaveta morreu (28/08). O rastreio de add_to_cart continua
     no AJAX do /cart/add.js, com os mesmos 150 ms de respiro pro beacon. */
  var adicionando = false;
  function botoesDe(form, submitter){
    var bs = [].slice.call(form.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"]'));
    if (submitter && bs.indexOf(submitter) < 0) bs.push(submitter);
    return bs;
  }
  function marcaBotoes(bs, on){
    bs.forEach(function(b){
      if (on) {
        if (b.__txt == null) b.__txt = b.tagName === 'INPUT' ? b.value : b.innerHTML;
        b.disabled = true; b.setAttribute('aria-busy', 'true'); b.classList.add('is-adicionando');
        if (b.tagName === 'INPUT') b.value = 'Adicionando…'; else b.textContent = 'Adicionando…';
      } else {
        b.disabled = false; b.removeAttribute('aria-busy'); b.classList.remove('is-adicionando');
        if (b.__txt != null) { if (b.tagName === 'INPUT') b.value = b.__txt; else b.innerHTML = b.__txt; b.__txt = null; }
      }
    });
  }
  /* voltar do /cart pelo "voltar" do celular restaura a página congelada (bfcache) — sem isto o
     botão ficaria preso em "Adicionando…" e travado */
  window.addEventListener('pageshow', function(){
    adicionando = false;
    marcaBotoes([].slice.call(document.querySelectorAll('.is-adicionando')), false);
  });

  function adicionar(form, submitter){
    if (adicionando) return Promise.resolve(); /* 2º toque enquanto a 1ª adição está em voo: ignora */
    adicionando = true;
    var bs = botoesDe(form, submitter);
    var fd = new FormData(form);
    if (submitter && submitter.name && !fd.has(submitter.name)) fd.append(submitter.name, submitter.value || '');
    marcaBotoes(bs, true);
    busy(true);
    return fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd })
      .then(function(r){
        if(!r.ok) return r.json().then(function(e){ throw e; });
        return r.json();
      })
      .then(function(){
        /* 16/10 (Will, prévia do DESKTOP): no computador a ABA LATERAL volta — o carrinho→checkout do
           desktop era 53% com ela (27/07–24/08) e caiu pra 42% depois que ela saiu; o celular não mudou
           (34%). Só com html.previa-desk: o cliente e o celular seguem indo pra página do carrinho. */
        if (window.pcnDesk()) {
          return refresh().then(function(){ adicionando = false; marcaBotoes(bs, false); busy(false); abrir(); });
        }
        /* 28/08 (Will): a ABA LATERAL morreu — depois do add, vai DIRETO pra página do
           carrinho. 150ms de respiro pro beacon do gtag. A trava fica ligada até sair da página. */
        setTimeout(function(){ window.location.href = '/cart'; }, 150);
      })
      /* Só reenviar o form quando a falha for de REDE (TypeError). Num 422 — estoque
         esgotado, limite por pedido — o repost falha de novo e joga a pessoa numa página
         de erro crua da Shopify, fora do tema. E se o /cart/add.js chegou ao servidor mas a
         resposta se perdeu, o repost adicionava o item DUAS vezes. */
      .catch(function(err){
        busy(false);
        if (err instanceof TypeError) { form.submit(); return; }
        adicionando = false;
        marcaBotoes(bs, false);
        var msg = (err && (err.description || err.message)) || 'Não foi possível adicionar agora. Tente de novo.';
        if (window.PoraoToast) window.PoraoToast(msg); else alert(msg);
        refresh();
      });
  }

  /* Campo de quantidade da PÁGINA do carrinho: aplica por AJAX ao sair do campo, e o Enter
     aplica em vez de submeter o form (o primeiro submit do form é o "Continuar" → a pessoa
     ia parar no CHECKOUT só por ter apertado Enter depois de digitar a quantidade). */
  document.addEventListener('keydown', function(e){
    var i = e.target.closest && e.target.closest('[data-cart-qty-input]');
    if (i && e.key === 'Enter') { e.preventDefault(); i.blur(); }
  });
  document.addEventListener('change', function(e){
    var i = e.target.closest && e.target.closest('[data-cart-qty-input]');
    if (!i) return;
    var q = parseInt(i.value, 10);
    /* bugfix 28/08: campo VAZIO/inválido NÃO é zero — apagar o valor e tocar fora (blur
       no meio da edição) REMOVIA o item sem aviso. Restaura a quantidade atual da linha
       (intenção pendente ou o valor renderizado pelo servidor no atributo value).
       Zero DIGITADO continua removendo — esse é gesto deliberado. */
    if (isNaN(q) || q < 0) {
      var f = filaQty[i.getAttribute('data-key')];
      var atual = f ? f.want : parseInt(i.defaultValue, 10);
      if (isNaN(atual) || atual < 0) atual = 1;
      i.value = atual;
      return;
    }
    i.value = q;
    mudar(i.getAttribute('data-key'), q);
  });

  /* ---------- delegação (sobrevive a re-render) ---------- */
  document.addEventListener('click', function(e){
    var t = e.target;

    /* O "Ver quadros" do carrinho vazio é um <a href> que TAMBÉM leva data-pcd-close.
       Com preventDefault em tudo, o único caminho de saída do carrinho vazio não ia a
       lugar nenhum: clicava e "não acontecia nada". Se o alvo tem href, deixa navegar —
       o drawer some junto com a página. */
    var fechaBtn = t.closest('[data-pcd-close]') || t.closest('[data-pcd-overlay]');
    if (fechaBtn) {
      var link = fechaBtn.tagName === 'A' && fechaBtn.getAttribute('href');
      if (!link) e.preventDefault();
      fechar();
      return;
    }

    /* abrir pelo ícone do carrinho (header desktop e item do menu mobile) */
    var abrirBtn = t.closest('.header__cart-btn, .mm__rail-btn--acao[href*="/cart"], [data-pcd-open]');
    if (abrirBtn) { e.preventDefault(); window.location.href = '/cart'; return; } /* 28/08: sem gaveta — vai pra página */

    var qb = t.closest('[data-pcd-qty]');
    if (qb) {
      e.preventDefault();
      var atual = parseInt(qb.getAttribute('data-qty'), 10) || 0;
      var novo = qb.getAttribute('data-pcd-qty') === 'inc' ? atual + 1 : atual - 1;
      if (novo < 0) novo = 0;
      mudar(qb.getAttribute('data-key'), novo);
      return;
    }

    var rm = t.closest('[data-pcd-remove]');
    if (rm) { e.preventDefault(); mudar(rm.getAttribute('data-key'), 0); return; }

    /* botões +/- da PÁGINA do carrinho: AJAX no lugar de submit da página inteira */
    var pb = t.closest('.porao-cart__qty-btn');
    if (pb) {
      var wrap = pb.closest('[data-cart-line]') || pb.closest('.porao-cart__item');
      var key = wrap && wrap.getAttribute('data-cart-line');
      var inp = pb.parentNode.querySelector('input');
      if (key && inp) {
        e.preventDefault(); e.stopPropagation();
        var q0 = parseInt(inp.value, 10) || 0;
        var q1 = /aumentar/i.test(pb.getAttribute('aria-label')||'') ? q0 + 1 : q0 - 1;
        if (q1 < 0) q1 = 0;
        inp.value = q1;
        mudar(key, q1);
      }
      return;
    }
  }, true);

  /* Adicionar ao carrinho (PDP e qualquer form de /cart/add) → AJAX + abre o drawer */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
    e.preventDefault();
    adicionar(f, e.submitter);
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && document.documentElement.classList.contains('pcd-open')) fechar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porao-cart"] && !Shopify.designMode) return;
  try {
    
  /* Corte de produção — urgência honesta (corte 17h, dias úteis, horário de Brasília).
     Agora vive como sublinha do "Chega até…" (Will 15/Jul): preenche todo [data-cutoff]. */
  (function () {
    function brNow() { var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset() * 60000 - 3 * 3600000); }
    /* bugfix 28/08: feriado nacional não é dia útil de produção — num feriado de semana o
       texto prometia "entra em produção ainda hoje" com a fábrica fechada */
    var FERIADOS_BR = ['2026-01-01','2026-02-16','2026-02-17','2026-04-03','2026-04-21','2026-05-01','2026-06-04','2026-09-07','2026-10-12','2026-11-02','2026-11-15','2026-11-20','2026-12-25','2027-01-01','2027-02-08','2027-02-09','2027-03-26','2027-04-21','2027-05-01','2027-05-27','2027-09-07','2027-10-12','2027-11-02','2027-11-15','2027-11-20','2027-12-25'];
    function ehFeriado(d) { var m = d.getMonth() + 1, dd = d.getDate(); return FERIADOS_BR.indexOf(d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dd < 10 ? '0' : '') + dd) !== -1; }
    var NOMES_PROD = ['', 'na segunda-feira', 'na terça-feira', 'na quarta-feira', 'na quinta-feira', 'na sexta-feira', ''];
    /* comProducao=false -> "Comprando dentro das próximas 3h 18min"
         usado na sublinha do "Chega até…": lá a data de chegada já está na tela,
         dizer "entra em produção amanhã" seria redundante (Will mandou tirar).
       comProducao=true  -> "... , entra em produção ainda hoje"
         usado no estado SEM CEP: não existe data na tela, então o dia da produção
         é justamente a informação útil. */
    function buildText(comProducao) {
      /* Mesma lógica da PDP: antes do corte conta até as 17h; depois (e fim de semana/feriado) conta até o fim do dia */
      var now = brNow(), day = now.getDay();
      var agora = now.getHours() * 60 + now.getMinutes();
      var CORTE = 17 * 60, FIM_DIA = 24 * 60;
      var biz = day >= 1 && day <= 5 && !ehFeriado(now);
      var falta, quando;
      if (biz && agora < CORTE) {
        falta = CORTE - agora;
        quando = 'ainda hoje';
      } else {
        falta = FIM_DIA - agora;
        /* bugfix 28/08: o próximo dia de produção pula fim de semana E feriado (antes,
           véspera de feriado prometia "amanhã" com a fábrica fechada). Sem feriado no
           caminho o texto é IDÊNTICO ao de antes: "amanhã" ou "na segunda-feira". */
        var prox = new Date(now);
        do { prox.setDate(prox.getDate() + 1); } while (prox.getDay() === 0 || prox.getDay() === 6 || ehFeriado(prox));
        var amanha = new Date(now); amanha.setDate(amanha.getDate() + 1);
        var ehAmanha = prox.getDate() === amanha.getDate() && prox.getMonth() === amanha.getMonth();
        quando = (ehAmanha && prox.getDay() !== 1) ? 'amanhã' : NOMES_PROD[prox.getDay()];
      }
      var hh = Math.floor(falta / 60), mm = falta % 60;
      var t, prefixo;
      if (hh >= 1) {
        t = mm > 0 ? (hh + 'h ' + mm + 'min') : (hh + 'h');
        prefixo = (hh === 1) ? 'dentro da próxima' : 'dentro das próximas';
      } else {
        t = mm + 'min';
        prefixo = (mm === 1) ? 'dentro do próximo' : 'dentro dos próximos';
      }
      var base = 'Comprando ' + prefixo + ' <strong>' + t + '</strong>';
      return comProducao ? (base + ', entra em produção <strong>' + quando + '</strong>') : base;
    }
    function tick() {
      // [data-cutoff]      = sublinha do "Chega até…" (curta, sem o dia da produção)
      // [data-cutoff-full] = dica do estado SEM CEP (com o dia da produção)
      var curtos = document.querySelectorAll('[data-cutoff]');
      var cheios = document.querySelectorAll('[data-cutoff-full]');
      if (curtos.length) {
        var a = buildText(false);
        for (var i = 0; i < curtos.length; i++) curtos[i].innerHTML = a;
      }
      if (cheios.length) {
        var b = buildText(true);
        for (var j = 0; j < cheios.length; j++) cheios[j].innerHTML = b;
      }
    }
    window.pdqCutoffTick = tick;
    tick();
    setInterval(tick, 30000);
  })();

  /* 20/08 (caçada): calculadora de CEP MOVIDA pra inline logo após o markup — era
     deferida e o botão Calcular ficava morto na janela de carregamento. */


  (function () {
    var cta = document.querySelector('.porao-cart__checkout');
    var bar = document.querySelector('[data-cart-sticky]');
    if (!cta || !bar || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(cta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porao-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    window.__hdrWired = true; /* bundle chegou: os handlers inline acima viram no-op */

    /* === Mobile menu — GAVETA lateral (Will 17/Jul) === */
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var mobileNav = header.querySelector('[data-mobile-nav]');
    var headerScrim = document.querySelector('[data-header-scrim]');
    if (menuToggle && mobileNav) {
      /* Trava no <html> E no <body>: só no body não funciona (ver comentário no CSS) */
      function travarPagina(travar) {
        document.documentElement.classList.toggle('menu-aberto', travar);
        document.body.classList.toggle('menu-aberto', travar);
      }
      function abrirMenu() {
        menuToggle.setAttribute('aria-expanded', 'true');
        mobileNav.classList.add('is-open');
        if (headerScrim) headerScrim.classList.add('is-open');
        travarPagina(true);
        /* bugfix 28/08 (#41): voltar do Android fecha o menu, não sai da página (padrão pdpz) */
        if (window.PoraoDrawerHist) window.PoraoDrawerHist.abriu('menu', fecharMenu);
        /* resolve os data-src da gaveta (círculos de ambiente) só agora, na 1ª abertura */
        mobileNav.querySelectorAll('img[data-src]').forEach(function(im){
          im.src = im.getAttribute('data-src');
          im.removeAttribute('data-src');
        });
      }
      function fecharMenu() {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('is-open');
        if (headerScrim) headerScrim.classList.remove('is-open');
        travarPagina(false);
      }
      /* bugfix 28/08 (#41): fechar pela UI consome a entrada do history; o popstate chama só o fecharMenu() */
      function fecharMenuUI() { fecharMenu(); if (window.PoraoDrawerHist) window.PoraoDrawerHist.fechouPelaUI('menu'); }
      function menuAberto() { return mobileNav.classList.contains('is-open'); }
      /* Apertar o menu de novo FECHA (Will: "volta pra página anterior") */
      menuToggle.addEventListener('click', function () {
        if (menuAberto()) fecharMenuUI(); else abrirMenu();
      });
      var menuClose = mobileNav.querySelector('[data-menu-close]');
      if (menuClose) menuClose.addEventListener('click', fecharMenuUI);
      if (headerScrim) headerScrim.addEventListener('click', fecharMenuUI);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menuAberto()) fecharMenuUI();
      });
    }

    /* === Megamenu desktop (hover + click + a11y) === */
    var dropdowns = header.querySelectorAll('[data-dropdown]');
    if (dropdowns.length) {
      var openDropdown = null;
      var closeTimer = null;
      var hoverEnabled = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches;

      function hydrate(d) {
        var imgs = d.querySelectorAll('img[data-src]');
        for (var i = 0; i < imgs.length; i++) {
          imgs[i].src = imgs[i].getAttribute('data-src');
          imgs[i].removeAttribute('data-src');
        }
        /* ARRASTAR CLICANDO no carrossel (Mais Vendidos / Lançamentos), não só na barra.
           Liga uma vez por carrossel. Segura o clique se a pessoa arrastou (senão abriria
           o produto sem querer). */
        var trilho = d.querySelector('.header__prod-grid');
        if (trilho && !trilho.dataset.dragOn) {
          trilho.dataset.dragOn = '1';
          trilho.style.cursor = 'grab';
          trilho.style.userSelect = 'none';
          /* 🔴 O QUE FAZIA NÃO FUNCIONAR: o navegador começa um "arrastar imagem/link"
             nativo (o fantasma) ao segurar num <img>/<a>, e isso CANCELA o pointermove.
             Por isso o teste com evento sintético passava mas o mouse real não arrastava.
             Solução: matar o drag nativo (draggable=false + preventDefault no dragstart)
             e capturar o ponteiro no trilho. */
          var els = trilho.querySelectorAll('img, a');
          for (var k = 0; k < els.length; k++) els[k].setAttribute('draggable', 'false');
          trilho.addEventListener('dragstart', function (e) { e.preventDefault(); });
          var down = false, moveu = false, x0 = 0, sl0 = 0, vel = 0, ultX = 0, ultT = 0, inercia = null;
          trilho.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'touch') return; /* toque rola nativo */
            if (inercia) { cancelAnimationFrame(inercia); inercia = null; }
            down = true; moveu = false; x0 = e.clientX; sl0 = trilho.scrollLeft;
            ultX = e.clientX; ultT = e.timeStamp || Date.now(); vel = 0;
            trilho.style.cursor = 'grabbing'; /* captura movida pro começo do ARRASTO (>4px): capturar no aperto matava o clique parado nos links */ });
          trilho.addEventListener('pointermove', function (e) {
            if (!down) return;
            var dx = e.clientX - x0;
            if (Math.abs(dx) > 4 && !moveu) { moveu = true; try { trilho.setPointerCapture(e.pointerId); } catch (_) {} }
            var tt = e.timeStamp || Date.now(), dt = tt - ultT;
            if (dt > 0) { vel = (e.clientX - ultX) / dt; ultX = e.clientX; ultT = tt; }
            trilho.scrollLeft = sl0 - dx;
          });
          var solta = function (e) {
            if (!down) return;
            down = false; trilho.style.cursor = 'grab';
            try { trilho.releasePointerCapture(e.pointerId); } catch (_) {}
            if (!moveu) return;
            /* inércia: continua no sentido do gesto e desacelera (mesmo padrão da home) */
            var v = vel * 15;
            (function passo() {
              if (Math.abs(v) < 0.25) { inercia = null; return; }
              trilho.scrollLeft -= v; v *= 0.945; inercia = requestAnimationFrame(passo);
            })();
          };
          trilho.addEventListener('pointerup', solta);
          trilho.addEventListener('pointercancel', solta);
          /* se arrastou, cancela o clique que abriria o produto */
          trilho.addEventListener('click', function (e) {
            if (moveu) { e.preventDefault(); e.stopPropagation(); moveu = false; }
          }, true);
        }
        /* SETAS do carrossel (Will 18/Jul): clicar anda ~1 tela, suave; some no fim/começo */
        var wrap = trilho ? trilho.closest('.header__prod-wrap') : null;
        if (wrap && trilho && !wrap.dataset.arrowOn) {
          wrap.dataset.arrowOn = '1';
          var prev = wrap.querySelector('[data-prod-prev]');
          var next = wrap.querySelector('[data-prod-next]');
          var passo = function () { return Math.max(220, Math.round(trilho.clientWidth * 0.8)); };
          var upd = function () {
            if (prev) prev.hidden = trilho.scrollLeft <= 4;
            if (next) next.hidden = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 4;
          };
          if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); trilho.scrollBy({ left: -passo(), behavior: 'smooth' }); });
          if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); trilho.scrollBy({ left: passo(), behavior: 'smooth' }); });
          trilho.addEventListener('scroll', upd, { passive: true });
          setTimeout(upd, 40);
        }
      }

      function closeAll(except) {
        for (var i = 0; i < dropdowns.length; i++) {
          if (dropdowns[i] !== except && dropdowns[i].open) dropdowns[i].open = false;
        }
        if (openDropdown !== except) openDropdown = except || null;
      }

      /* Ancora o painel MEGA embaixo do item que o abriu (os simples já são âncorados
         por CSS). Trava nas bordas: item da ponta não faz o painel vazar da tela. */
      function posicionarPainel(d) {
        var painel = d.querySelector('.header__nav-dropdown-panel');
        var gatilho = d.querySelector('summary');
        if (!painel || !gatilho) return;
        if (getComputedStyle(painel).position !== 'fixed') return;  /* absoluto já está ok */
        painel.style.transform = 'none';
        painel.style.left = '0px';                                   /* mede a largura real */
        var larg = painel.offsetWidth;
        var g = gatilho.getBoundingClientRect();
        var vw = document.documentElement.clientWidth;
        var margem = 16;
        /* ANCORADO no item: o painel começa na borda esquerda do gatilho.
           Centralizar (o que era feito aqui) jogava um painel de 720px 300px pra esquerda
           de um item de 114px — parecia que abria no meio da tela. */
        var esq = g.left;
        if (esq + larg > vw - margem) esq = vw - margem - larg;
        if (esq < margem) esq = margem;
        painel.style.left = Math.round(esq) + 'px';
      }
      function openOne(d) {
        clearTimeout(closeTimer);
        if (d.open) return;
        d.open = true;
        posicionarPainel(d);
      }
      window.addEventListener('resize', function () {
        var aberto = header.querySelector('[data-dropdown][open]');
        if (aberto) posicionarPainel(aberto);
      });
      /* O <details> abre nativamente no clique do <summary> — sem passar pelo openOne.
         O evento 'toggle' pega TODA abertura (clique, teclado e hover). */
      [].forEach.call(dropdowns, function (d) {
        d.addEventListener('toggle', function () { if (d.open) posicionarPainel(d); });
      });

      function scheduleClose(d) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (d.open) d.open = false;
        }, 180);
      }

      for (var i = 0; i < dropdowns.length; i++) {
        (function (d) {
          d.addEventListener('toggle', function () {
            if (d.open) {
              hydrate(d);
              closeAll(d);
              /* Abrir um menu FECHA a busca (Will 22/Jul): sem isso, com a busca aberta,
                 passar o mouse num menu abria o mega POR CIMA das sugestões e os dois
                 ficavam abertos. É o par simétrico do fecharNav() do bloco da busca. */
              var hsAberta = document.querySelector('[data-hs]:not([hidden])');
              if (hsAberta) hsAberta.hidden = true;
              openDropdown = d;
            } else if (openDropdown === d) {
              openDropdown = null;
            }
          });

          if (hoverEnabled) {
            d.addEventListener('mouseenter', function () {
              clearTimeout(closeTimer);
              openOne(d);
            });
            d.addEventListener('mouseleave', function () {
              scheduleClose(d);
            });

            /* Bug-fix: no desktop, hover já abriu o menu. Se o usuário clicar
               no summary, o <details> nativo fecharia. Cancelamos o click — clique
               no summary com menu aberto (hover) é no-op (mantém aberto). */
            var summary = d.querySelector('summary');
            if (summary) {
              summary.addEventListener('click', function (e) {
                if (d.open) {
                  e.preventDefault();
                }
              });
            }
          }
        })(dropdowns[i]);
      }

      /* Listeners globais ATIVOS apenas enquanto algum dropdown está aberto */
      function onDocClick(e) {
        if (!openDropdown) return;
        if (openDropdown.contains(e.target)) return;
        /* alvo já saiu do DOM (conteúdo do painel re-renderizou) → NÃO fecha */
        if (!document.documentElement.contains(e.target)) return;
        closeAll(null);
      }
      function onKeydown(e) {
        if (!openDropdown) return;
        if (e.key === 'Escape') {
          var summary = openDropdown.querySelector('summary');
          closeAll(null);
          if (summary) summary.focus();
        }
      }
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKeydown);
    }

    /* === Announcement bar rotation (pausa em bg + fora da viewport) === */
    var msgs = header.querySelectorAll('[data-announcement-msg]');
    if (msgs.length > 1) {
      var idx = 0;
      var timer = null;
      var visible = true;

      function tick() {
        msgs[idx].classList.remove('header__top-bar-msg--active');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('header__top-bar-msg--active');
      }
      function start() {
        if (!timer && !document.hidden && visible) timer = setInterval(tick, 4000);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });

      var bar = header.querySelector('[data-announcement-bar]');
      if (bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          visible ? start() : stop();
        }).observe(bar);
      } else {
        start();
      }
    }

    /* === Sticky header com shrink-on-scroll === */
    var scrolled = false;
    var rafId = 0;
    /* Leitura via ResizeObserver (27/07): o offsetHeight — mesmo dentro de rAF — forçava
       o layout da página INTEIRA antes da 1ª pintura (101ms no trace). O RO entrega a
       altura já calculada (pós-layout, pré-pintura): zero reflow, mesmo timing visual,
       e ainda corrige sozinho se o header mudar (resize, fonte do ticker).
       ⚠️ NÃO atualizar no modo fixo: header--scrolled esconde o top-bar e ENCOLHE o header;
       o spacer precisa da altura CHEIA, senão o conteúdo pula ~37px ao rolar.
       ⚠️ HISTÓRICO: requestIdleCallback JÁ FOI TENTADO e deu CLS 0,78 — dispara DEPOIS da
       pintura. Defaults REAIS (56px mobile / 153px desktop) declarados no :root do CSS desta secao. */
    var headerHeight = 0;
    function aplicaSpacer(h) {
      h = Math.round(h);
      if (!h || h === headerHeight) return;
      headerHeight = h;
      /* so escreve se o CSS ja nao estiver certo — setProperty no :root invalida o estilo
         da pagina inteira e alguem paga o layout de novo (102ms no trace quando escrevia sempre) */
      var atual = Math.round(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-spacer')) || 0);
      if (atual === h) return;
      document.documentElement.style.setProperty('--header-spacer', h + 'px');
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function (en) {
        if (scrolled) return;
        var bb = en[0].borderBoxSize;
        aplicaSpacer(bb && bb.length ? bb[0].blockSize : en[0].contentRect.height);
      }).observe(header);
    } else {
      requestAnimationFrame(function () { aplicaSpacer(header.offsetHeight); });
    }
    /* Gatilho do sticky. No MOBILE ele aparecia cedo demais (100px), atrapalhando a leitura
       logo no começo da página. Agora só aparece a 500px — o MESMO ponto em que surge a seta
       "voltar ao topo" (porao-whatsapp.liquid), então os dois entram em cena juntos.
       No desktop segue em 100px, onde o header fixo é esperado. (Will, 13/Jul) */
    var LIMITE_DESKTOP = 100;
    var LIMITE_MOBILE = 500;
    var mqDesk = window.matchMedia('(min-width: 990px)');
    var limite = mqDesk.matches ? LIMITE_DESKTOP : LIMITE_MOBILE;
    window.addEventListener('resize', function () {
      limite = mqDesk.matches ? LIMITE_DESKTOP : LIMITE_MOBILE;
    }, { passive: true });

    /* Direção do gesto: a setinha de voltar só aparece quando a pessoa SOBE a tela
       (e já passou da primeira dobra). Descendo, ela recolhe — a tela é da obra.
       TOLERANCIA evita que tremida de dedo fique piscando o botão. */
    var TOLERANCIA = 8;
    var ultimoY = window.scrollY;
    var subindo = false;

    window.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        var y = window.scrollY;
        var now = y > limite;
        if (now !== scrolled) {
          scrolled = now;
          header.classList.toggle('header--scrolled', scrolled);
          document.body.classList.toggle('header-fixed', scrolled);
          /* altura REAL do header rolado -> é o quanto ele sobe pra sumir.
             Mede no frame seguinte, quando o CSS de --scrolled já valeu. */
          if (scrolled) {
            requestAnimationFrame(function () {
              var alt = header.querySelector('.header__main');
              document.documentElement.style.setProperty(
                '--header-alt', Math.round((alt ? alt.offsetHeight : header.offsetHeight)) + 'px'
              );
            });
          }
        }

        /* Will 18/Jul: header FIXO NO TOPO SEMPRE — não some mais ao descer. Quando rolado,
           fica sempre visível (header--subindo travado em true), e a barra de filtros gruda
           logo abaixo dele. Antes ele sumia ao descer e a barra aparecia "só ela". */
        if (scrolled) {
          if (!subindo) { subindo = true; header.classList.add('header--subindo'); }
        } else {
          if (subindo) { subindo = false; header.classList.remove('header--subindo'); }
        }
        ultimoY = y;

        /* header nunca mais fica escondido → a pílula "Comprar"/seta topo ficam sempre visíveis */
        document.body.classList.toggle('header-escondido', false);

        rafId = 0;
      });
    }, { passive: true });

    /* === A SETINHA DE VOLTAR (Will 17/Jul; QUIZ removido 31/08) ===
       A pessoa vai voltando pelas páginas do site normalmente; QUANDO chega na PÁGINA DE
       ENTRADA (a 1ª da visita — onde o próximo voltar a jogaria PRA FORA do site), a
       setinha, em vez de deixar sair, manda pra HOME (e, da home, pros mais vendidos —
       laço final home ↔ mais-vendidos, sem sequestrar o botão do navegador).
       "Entrada" = 1ª URL (pathname) desta aba, guardada em sessionStorage. */
    var K_ENTRADA = 'pdq_entrada';
    try { if (!sessionStorage.getItem(K_ENTRADA)) sessionStorage.setItem(K_ENTRADA, location.pathname); } catch (e) {}

    var btnVoltar = header.querySelector('[data-header-voltar]');
    if (btnVoltar) {
      btnVoltar.addEventListener('click', function (e) {
        e.preventDefault(); /* 20/08: o elemento agora é <a> nativo — o bundle assume daqui */
        var entrada = null;
        try { entrada = sessionStorage.getItem(K_ENTRADA); } catch (e) {}
        var naEntrada = (entrada && location.pathname === entrada);
        /* Na home, "voltar" convida pros mais vendidos (não deixa sair do site) */
        if (location.pathname === '/') { window.location.href = '/collections/mais-vendidos'; return; }
        /* Está na página de onde o voltar sairia do site → leva pra home */
        if (naEntrada) { window.location.href = '/'; return; }
        /* Ainda tem página do site atrás → volta normal */
        if (history.length > 1) { history.back(); return; }
        /* Sem histórico (entrou direto e não navegou) → home, não pra fora */
        window.location.href = '/';
      });
    }

    /* === Menu mobile master-detail (estilo ML): toca no eixo, troca o painel === */
    var mmTabs = header.querySelectorAll('[data-mm-tab]');
    var mmPanels = header.querySelectorAll('[data-mm-panel]');

    /* ── conteúdo dos painéis Favoritos e Carrinho (Will 22/Jul) ──
       Favoritos vem do localStorage (mesma chave do coração dos cards); carrinho vem do
       /cart.js, que é o estado real — o objeto `cart` do Liquid é do carregamento da página
       e ficaria velho depois de qualquer "adicionar ao carrinho" por JS. */
    var favBox  = header.querySelector('[data-mm-favs]');
    var cartBox = header.querySelector('[data-mm-cart]');
    var cartCta = header.querySelector('[data-mm-cart-cta]');
    function mmEsc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function mmMoeda(c){ var n=Number(c)/100; return (isFinite(n)&&n>0) ? 'R$ '+n.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}) : ''; }
    function mmThumb(u,w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; if(/[?&]width=/.test(u)) return u;
      return u.replace(/(_\d+x\d*)?(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_'+w+'x$2$3'); }
    function mmItem(url, img, nome, sub, removeId){
      var a = '<a class="mm__li" href="'+mmEsc(url||'#')+'">'+
        (img ? '<img src="'+mmEsc(mmThumb(img,120))+'" alt="" loading="lazy" width="56" height="56">' : '<img alt="" width="56" height="56">')+
        '<span class="mm__li-txt"><span class="mm__li-nome">'+mmEsc(nome)+'</span>'+
        (sub ? '<span class="mm__li-sub">'+mmEsc(sub)+'</span>' : '')+'</span></a>';
      if(removeId!=null && removeId!==''){
        return '<div class="mm__li-wrap">'+a+'<button type="button" class="mm__li-rm" data-fav-remove="'+mmEsc(String(removeId))+'" aria-label="Remover dos favoritos"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>';
      }
      return a;
    }
    function pintaFavs(){
      if(!favBox) return;
      var favs=[]; try{ favs = JSON.parse(localStorage.getItem('pdq_wishlist_v1')) || []; }catch(e){}
      if(!Array.isArray(favs) || !favs.length){
        favBox.innerHTML = '<div class="mm__lista-vazio"><b>Nenhum quadro favoritado ainda.</b>'+
          'Toque no coração dos quadros que você gostar — eles ficam guardados aqui.</div>';
        return;
      }
      favBox.innerHTML = favs.map(function(f){
        return mmItem(f.url || f.handle && ('/products/'+f.handle), f.image || f.img, f.title || f.nome || 'Quadro', mmMoeda(f.price), f.id);
      }).join('');
      /* X pra remover favorito do menu mobile (Will 23/Jul): mesma API global dos corações */
      if(!favBox.__rmWired){
        favBox.__rmWired = true;
        favBox.addEventListener('click', function(e){
          var rm = e.target.closest ? e.target.closest('[data-fav-remove]') : null;
          if(!rm) return;
          e.preventDefault(); e.stopPropagation();
          var id = rm.getAttribute('data-fav-remove');
          try{
            if(window.PoraoWishlist && window.PoraoWishlist.remove){ window.PoraoWishlist.remove(id); if(window.PoraoWishlist.sync) window.PoraoWishlist.sync(); }
            else { var l=JSON.parse(localStorage.getItem('pdq_wishlist_v1'))||[]; l=l.filter(function(it){ return String(it.id)!==String(id); }); localStorage.setItem('pdq_wishlist_v1', JSON.stringify(l)); }
          }catch(err){}
          pintaFavs();
        });
      }
    }
    var cartCarregando = false;
    function pintaCarrinho(){
      if(!cartBox || cartCarregando) return;
      cartCarregando = true;
      cartBox.innerHTML = '<div class="mm__lista-vazio">Carregando…</div>';
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(c){
          cartCarregando = false;
          if(!c || !c.items || !c.items.length){
            cartBox.innerHTML = '<div class="mm__lista-vazio"><b>Seu carrinho está vazio.</b>'+
              'Escolha um quadro e ele aparece aqui.</div>';
            if(cartCta) cartCta.hidden = true;
            return;
          }
          cartBox.innerHTML = c.items.map(function(it){
            var qtd = it.quantity > 1 ? it.quantity+'× · ' : '';
            return mmItem(it.url, it.image, it.product_title || it.title, qtd + mmMoeda(it.final_line_price));
          }).join('') + '<div class="mm__li" style="border:0;font-weight:700"><span class="mm__li-txt">'+
            '<span class="mm__li-nome">Total</span></span><span class="mm__li-sub" style="margin-left:auto">'+
            mmMoeda(c.total_price)+'</span></div>';
          if(cartCta) cartCta.hidden = false;
        })
        .catch(function(){
          cartCarregando = false;
          cartBox.innerHTML = '<div class="mm__lista-vazio"><b>Não consegui carregar o carrinho.</b>'+
            '<a href="/cart">Abrir a página do carrinho</a></div>';
        });
    }

    if (mmTabs.length) {
      var mmPanelsBox = header.querySelector('.mm__panels');
      for (var mi = 0; mi < mmTabs.length; mi++) {
        mmTabs[mi].addEventListener('click', function (ev) {
          var idx = this.getAttribute('data-mm-tab');
          /* Favoritos e Carrinho são <a> com href real (funcionam sem JS). Com JS, abrem
             no painel em vez de navegar — por isso o preventDefault só aqui.
             ⚠️ stopPropagation é obrigatório: a gaveta do carrinho tem um listener no
             DOCUMENT que abre por `.mm__rail-btn--acao[href*="/cart"]` — sem barrar, o painel
             abria no menu E a gaveta subia por cima dele. O ícone do carrinho no header
             (.header__cart-btn) não é afetado: lá a gaveta continua sendo o certo. */
          if (this.tagName === 'A') { ev.preventDefault(); ev.stopPropagation(); }
          for (var a = 0; a < mmTabs.length; a++) {
            var on = mmTabs[a] === this;
            mmTabs[a].classList.toggle('is-active', on);
            mmTabs[a].setAttribute('aria-selected', on ? 'true' : 'false');
          }
          for (var b = 0; b < mmPanels.length; b++) {
            mmPanels[b].classList.toggle('is-active', mmPanels[b].getAttribute('data-mm-panel') === idx);
          }
          if (idx === 'favoritos') pintaFavs();
          if (idx === 'carrinho') pintaCarrinho();
          /* volta o painel pro topo ao trocar de eixo */
          if (mmPanelsBox) mmPanelsBox.scrollTop = 0;
        });
      }
    }

    /* === Mobile search overlay === */
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchOverlay = document.getElementById('search-overlay');
    var searchCloses = header.querySelectorAll('[data-search-close]'); /* setinha E "Cancelar" */
    var searchInput = document.getElementById('search-overlay-input');

    if (searchToggle && searchOverlay) {
      /* bugfix 28/08 (#41): callback do popstate — fecha o painel E destrava a rolagem
         (.busca-aberta é posta pelo handler da lupa mais abaixo neste bundle) */
      function fecharBuscaHist() {
        searchOverlay.classList.remove('is-open');
        document.documentElement.classList.remove('busca-aberta');
        document.body.classList.remove('busca-aberta');
      }
      searchToggle.addEventListener('click', function () {
        searchOverlay.classList.add('is-open');
        if (window.PoraoDrawerHist) window.PoraoDrawerHist.abriu('busca', fecharBuscaHist); /* bugfix 28/08 (#41) */
        if (searchInput) setTimeout(function(){ searchInput.focus(); }, 60);
      });
      searchCloses.forEach(function (btn) {
        btn.addEventListener('click', function () {
          searchOverlay.classList.remove('is-open');
          if (window.PoraoDrawerHist) window.PoraoDrawerHist.fechouPelaUI('busca'); /* bugfix 28/08 (#41) */
          searchToggle.focus();
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
          searchOverlay.classList.remove('is-open');
          if (window.PoraoDrawerHist) window.PoraoDrawerHist.fechouPelaUI('busca'); /* bugfix 28/08 (#41) */
          searchToggle.focus();
        }
      });
    }
  })();


  /* MOVIDO DO INLINE (27/07): rodava em <script> no corpo e inflava o HTML de toda pagina.
     Aqui compila pro scripts.js (cacheado, deferred). IIFE com guard proprio. */
(function () {
  var CHAVE = 'pdq_buscas_v1';

  var formD  = document.querySelector('.header__search-desktop');
  var inD    = formD && formD.querySelector('.header__search-input');
  var dropD  = formD && formD.querySelector('[data-hs]');
  var boxD   = formD && formD.querySelector('[data-hs-box]');
  var btnD   = formD && formD.querySelector('.header__search-submit');

  var painel = document.getElementById('search-overlay');
  var formM  = painel && painel.querySelector('.header__search-panel-form');
  var inM    = document.getElementById('search-overlay-input');
  var boxM   = painel && painel.querySelector('[data-hsm-box]');

  var POP = [];
  try { POP = JSON.parse(document.querySelector('[data-hs-pop]').textContent) || []; } catch (e) {}
  /* 20/08: "Mais buscados" VIVO — /populares devolve o que os clientes buscaram nos
     últimos 7 dias E que retorna resultado. Os blocos estáticos da seção viram fallback
     instantâneo até a resposta chegar. Cache de sessão 30min. */
  (function () {
    try {
      var cx = sessionStorage.getItem('hs_pop_vivo');
      if (cx) { var j = JSON.parse(cx); if (j.ts > Date.now() - 18e5 && j.l.length) { POP = j.l; return; } }
    } catch (e) {}
    fetch('https://busca.poraodosquadros.app/populares?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var l = (j.termos || []).map(function (q) { return { t: q, u: urlBusca(q) }; });
        if (l.length >= 4) { POP = l; try { sessionStorage.setItem('hs_pop_vivo', JSON.stringify({ ts: Date.now(), l: l })); } catch (e) {} }
      })
      .catch(function () {});
  })();

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function lerJSON(k) {
    try { var v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function hist() { return lerJSON(CHAVE); }
  function gravarHist(l) { try { localStorage.setItem(CHAVE, JSON.stringify(l.slice(0, 6))); } catch (e) {} }
  function guardar(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var l = hist().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    l.unshift(q);
    gravarHist(l);
  }
  function brl(n) {
    n = Number(n);
    if (!isFinite(n) || n <= 0) return '';
    return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // /search/suggest.json devolve em REAIS ('687.00'); o localStorage, em CENTAVOS (68700).
  // Misturar os dois mostrava 'R$ 6,87'. Dois formatadores, sem ambiguidade.
  function moneyApi(v) { return brl(v); }
  function moneyCent(v) { return brl(Number(v) / 100); }
  function img(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/[?&]width=/.test(u)) return u;
    return u.replace(/(_\d+x\d*)?(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$2$3');
  }
  function urlBusca(q) { return '/search?type=product&q=' + encodeURIComponent(q); }

  var RELOGIO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var LUPA    = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
  var SETA    = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var XIS     = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var CHEV    = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  /* uma chamada só para os dois. 1ª opção: o MOTOR PRÓPRIO (busca.poraodosquadros.app,
     Meilisearch no VPS) — tolera erro de digitação em qualquer posição ("asul" acha azul;
     a preditiva nativa devolve 0), sinônimos PT e ranking por vendas. Se o motor não
     responder em 900ms (ou der erro), cai SOZINHO na /search/suggest.json nativa — o site
     nunca fica sem busca por causa do serviço (fail-open, mesmo princípio do pixel). */
  var cache = {};
  function viaMotor(q) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 900) : null;
    return fetch('https://busca.poraodosquadros.app/busca?q=' + encodeURIComponent(q) + '&limit=6',
      ctl ? { signal: ctl.signal } : {})
      .then(function (r) {
        if (timer) clearTimeout(timer);
        if (!r.ok) throw new Error('motor http ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var lista = (j.hits || []).map(function (h) {
          return {
            title: h.titulo,
            url: '/products/' + h.handle,
            featured_image: h.imagem ? { url: h.imagem } : null,
            price: String(h.preco_min)
          };
        });
        if (j.semantico) lista.semantico = true;   /* resgate por significado → UI rotula */
        return lista;
      });
  }
  function viaNativa(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6',
      { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return (j.resources && j.resources.results && j.resources.results.products) || [];
      });
  }
  function sugerir(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    return viaMotor(q)
      .catch(function () { return viaNativa(q); })
      .then(function (ps) { cache[q] = ps; return ps; })
      /* ⚠️ Falha de rede NÃO é "não temos esse quadro". Devolvendo [] no catch, a tela dizia
         "Nada com «leão»" quando na verdade a requisição caiu — em 4G instável o cliente
         concluía que a loja não tem o produto e ia embora. Marcamos o erro pra UI dizer a
         verdade e convidar a tentar de novo. */
      .catch(function () { var e = []; e.erroDeRede = true; return e; });
  }
  /* 20/08: zero-resultado NUNCA é beco sem saída — anexa os mais amados. */
  var MV = null;
  function anexaMaisVendidos(box, aindaVale) {
    var p = MV ? Promise.resolve(MV) : fetch('/collections/mais-vendidos/products.json?limit=4')
      .then(function (r) { return r.json(); })
      .then(function (j) { MV = (j.products || []).slice(0, 4); return MV; });
    p.then(function (ps) {
      if (!ps || !ps.length || !aindaVale()) return;
      var h = '<p class="hs__t">Enquanto isso, os mais amados do Porão:</p><div class="hs__pgrid">';
      ps.forEach(function (pr) {
        var u = (pr.images && pr.images[0] && pr.images[0].src) || '';
        var t = (pr.title || '').replace(/^Quadro Decorativo:?[ ]*/i, '').split(':')[0].split(' - ')[0].trim();
        h += '<a class="hs__i hs__pcard" href="/products/' + esc(pr.handle) + '">' +
             (u ? '<span class="hs__pimg"><img src="' + esc(img(u, 300)) + '" alt="" aria-hidden="true" loading="lazy" decoding="async"></span>' : '') +
             '<span class="hs__pt">' + esc(t) + '</span></a>';
      });
      h += '</div>';
      var d = document.createElement('div');
      d.innerHTML = h;
      while (d.firstChild) box.appendChild(d.firstChild);
    }).catch(function () {});
  }

  function realce(titulo, q) {
    var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, function (m) { return '\\' + m; }) + ')', 'ig');
    return esc(titulo).replace(re, '<mark>$1</mark>');
  }

  /* ═══════════ DESKTOP ═══════════ */
  if (formD && inD && dropD && boxD) {
    var t1 = null, itens = [], sel = -1;
    /* Abrir a busca FECHA qualquer menu do nav (Will 22/Jul): com o mega de Coleções aberto,
       ele e os rótulos do menu apareciam POR CIMA das sugestões. Só subir o z-index resolveria
       a pintura, mas continuaria errado ter dois painéis abertos disputando a mesma área. */
    var fecharNav = function () {
      var ds = document.querySelectorAll('.header__nav-dropdown[open]');
      for (var i = 0; i < ds.length; i++) ds[i].open = false;
    };
    var abrir = function () { fecharNav(); dropD.hidden = false; };
    var fechar = function () { dropD.hidden = true; sel = -1; };

    var vazioD = function () {
      var h = '', hs = hist();
      if (hs.length) {
        h += '<p class="hs__t">Suas buscas</p>';
        hs.forEach(function (q) {
          h += '<a class="hs__i" href="' + urlBusca(q) + '" data-q="' + esc(q) + '">' + RELOGIO +
               '<b>' + esc(q) + '</b><button type="button" class="hs__x" data-hs-del="' + esc(q) +
               '" aria-label="Remover do histórico">' + XIS + '</button></a>';
        });
      }
      if (POP.length) {
        h += '<p class="hs__t">Mais buscados</p>';
        POP.forEach(function (p) {
          h += '<a class="hs__i" href="' + esc(p.u) + '">' + LUPA + '<b>' + esc(p.t) + '</b></a>';
        });
      }
      boxD.innerHTML = h || '<p class="hs__none">Comece a digitar para ver os quadros.</p>';
      itens = [].slice.call(boxD.querySelectorAll('.hs__i'));
      sel = -1;
      abrir();
    };

    var buscaD = function (q) {
      sugerir(q).then(function (ps) {
        if (inD.value.trim() !== q) return; // ela já digitou outra coisa
        var h = '';
        if (!ps.length) {
          h = ps.erroDeRede
            ? '<p class="hs__none">Não consegui buscar agora — parece a conexão. Tente de novo em instantes.</p>'
            : '<p class="hs__none">Não achamos nada com “' + esc(q) + '”.</p>';
        } else {
          if (ps.semantico) h += '<p class="hs__t">Não achamos exato — talvez você goste:</p>';
          h += '<div class="hs__pgrid">';
          ps.slice(0, 4).forEach(function (p) {
            var u = (p.featured_image && p.featured_image.url) || '';
            // título curto: tira o "Quadro Decorativo" e o que vem depois de ":" ou "-"
            var t = (p.title || '').replace(/^Quadro Decorativo:?\s*/i, '').split(':')[0].split(' - ')[0].trim();
            h += '<a class="hs__i hs__pcard" href="' + esc(p.url) + '">' +
                 (u ? '<span class="hs__pimg"><img src="' + esc(img(u, 300)) + '" alt="" aria-hidden="true" loading="lazy" decoding="async"></span>' : '') +
                 '<span class="hs__pt">' + esc(t) + '</span></a>';
          });
          h += '</div>';
        }
        h += '<a class="hs__i hs__all" href="' + urlBusca(q) + '" data-q="' + esc(q) + '">' + SETA +
             '<b>Ver todos os resultados de “' + esc(q) + '”</b></a>';
        boxD.innerHTML = h;
        if (!ps.length && !ps.erroDeRede) anexaMaisVendidos(boxD, function () { return inD.value.trim() === q; });
        itens = [].slice.call(boxD.querySelectorAll('.hs__i'));
        sel = -1;
        abrir();
      });
    };

    var pintarD = function () {
      var q = inD.value.trim();
      if (q.length >= 2) buscaD(q); else vazioD();
    };

    inD.addEventListener('focus', pintarD);
    /* Reabrir ao CLICAR no campo (Will 22/Jul): as sugestões só abriam no 'focus'. Quando
       abrir um menu fecha a busca, o campo CONTINUA focado — então clicar nele de novo não
       dispara 'focus' outra vez e nada reabria (só a lupa, que chama pintarD direto). Aqui
       o clique reabre se o painel estiver escondido; a guarda evita re-render quando já aberto. */
    inD.addEventListener('click', function () { if (dropD.hidden) pintarD(); });
    inD.addEventListener('input', function () {
      clearTimeout(t1);
      var q = inD.value.trim();
      if (q.length < 2) { vazioD(); return; }
      t1 = setTimeout(function () { buscaD(q); }, 180);
    });

    // Will: a lupa com o campo VAZIO abre as sugestões — não envia o formulário.
    // Só navega depois de digitar (ou ao tocar numa sugestão).
    if (btnD) btnD.addEventListener('click', function (e) {
      if (!inD.value.trim()) { e.preventDefault(); inD.focus(); pintarD(); }
    });
    formD.addEventListener('submit', function (e) {
      if (!inD.value.trim()) { e.preventDefault(); inD.focus(); pintarD(); return; }
      guardar(inD.value);
    });

    inD.addEventListener('keydown', function (e) {
      if (dropD.hidden || !itens.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        itens.forEach(function (x) { x.classList.remove('is-on'); });
        sel = e.key === 'ArrowDown' ? (sel + 1) % itens.length : (sel <= 0 ? itens.length - 1 : sel - 1);
        itens[sel].classList.add('is-on');
        itens[sel].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && sel > -1) {
        e.preventDefault();
        itens[sel].click();
      } else if (e.key === 'Escape') { fechar(); inD.blur(); }
    });

    boxD.addEventListener('click', function (e) {
      var d = e.target.closest('[data-hs-del]');
      if (d) {
        e.preventDefault(); e.stopPropagation();
        var q = d.getAttribute('data-hs-del');
        gravarHist(hist().filter(function (x) { return x !== q; }));
        vazioD();
        return;
      }
      var it = e.target.closest('[data-q]');
      if (it) guardar(it.getAttribute('data-q'));
    });

    document.addEventListener('click', function (e) { if (!formD.contains(e.target)) fechar(); });
  }

  /* ═══════════ MOBILE (painel de tela cheia — o tema já tinha, estava vazio) ═══════════ */
  if (painel && inM && boxM) {
    var t2 = null;

    /* Campo vazio: pílulas (histórico dela + populares) e, embaixo, produtos REAIS dela —
       o que ela viu por último e os favoritos. Zero backend: sai do mesmo localStorage
       do "Continue de onde parou" e dos Favoritos. */
    var vazioM = function () {
      var hs = hist(), h = '';
      var chips = '';
      hs.forEach(function (q) {
        chips += '<a class="hsm__chip hsm__chip--hist" href="' + urlBusca(q) + '" data-q="' + esc(q) + '">' +
                 RELOGIO + esc(q) + '</a>';
      });
      POP.forEach(function (p) {
        chips += '<a class="hsm__chip" href="' + esc(p.u) + '">' + esc(p.t) + '</a>';
      });
      var total = hs.length + POP.length;
      h += '<div class="hsm__chips' + (total > 6 ? ' is-corta' : '') + '">' + chips + '</div>';
      if (total > 6) h += '<button type="button" class="hsm__mais" data-hsm-mais>Ver mais ' + CHEV + '</button>';

      var vistos = lerJSON('pdq_recent_v1');
      var favs   = lerJSON('pdq_wishlist_v1');
      var trilho = '';
      vistos.slice(0, 6).forEach(function (p) {
        trilho += '<a class="hsm__c" href="' + esc(p.url) + '">' +
          '<img src="' + esc(img(p.image, 280)) + '" alt="" aria-hidden="true" width="132" height="132" loading="lazy" decoding="async">' +
          '<small>Você viu</small><b>' + esc(p.title) + '</b>' +
          (p.price ? '<i>' + moneyCent(p.price) + '</i>' : '') + '</a>';
      });
      favs.slice(0, 4).forEach(function (p) {
        trilho += '<a class="hsm__c" href="' + esc(p.url) + '">' +
          '<img src="' + esc(img(p.image, 280)) + '" alt="" aria-hidden="true" width="132" height="132" loading="lazy" decoding="async">' +
          '<small>Seu favorito</small><b>' + esc(p.title) + '</b>' +
          (p.price ? '<i>' + moneyCent(p.price) + '</i>' : '') + '</a>';
      });
      if (trilho) h += '<div class="hsm__rail">' + trilho + '</div>';

      boxM.innerHTML = h;
    };

    var buscaM = function (q) {
      sugerir(q).then(function (ps) {
        if (inM.value.trim() !== q) return;
        var h = '';
        if (!ps.length) {
          h = ps.erroDeRede
            ? '<p class="hs__none">Não consegui buscar agora — parece a conexão. Tente de novo em instantes.</p>'
            : '<p class="hs__none">Não achamos nada com “' + esc(q) + '”.</p>';
        } else {
          if (ps.semantico) h += '<p class="hs__t">Não achamos exato — talvez você goste:</p>';
          h += '<div class="hs__pgrid">';
          ps.slice(0, 4).forEach(function (p) {
            var u = (p.featured_image && p.featured_image.url) || '';
            // título curto: tira o "Quadro Decorativo" e o que vem depois de ":" ou "-"
            var t = (p.title || '').replace(/^Quadro Decorativo:?\s*/i, '').split(':')[0].split(' - ')[0].trim();
            h += '<a class="hs__i hs__pcard" href="' + esc(p.url) + '">' +
                 (u ? '<span class="hs__pimg"><img src="' + esc(img(u, 300)) + '" alt="" aria-hidden="true" loading="lazy" decoding="async"></span>' : '') +
                 '<span class="hs__pt">' + esc(t) + '</span></a>';
          });
          h += '</div>';
        }
        h += '<a class="hs__i hs__all" href="' + urlBusca(q) + '" data-q="' + esc(q) + '">' + SETA +
             '<b>Ver todos os resultados de “' + esc(q) + '”</b></a>';
        boxM.innerHTML = h;
        if (!ps.length && !ps.erroDeRede) anexaMaisVendidos(boxM, function () { return inM.value.trim() === q; });
      });
    };

    var pintarM = function () {
      var q = inM.value.trim();
      if (q.length >= 2) buscaM(q); else vazioM();
    };

    inM.addEventListener('input', function () {
      clearTimeout(t2);
      var q = inM.value.trim();
      if (q.length < 2) { vazioM(); return; }
      t2 = setTimeout(function () { buscaM(q); }, 180);
    });
    inM.addEventListener('focus', pintarM);

    if (formM) formM.addEventListener('submit', function (e) {
      // igual ao desktop: lupa com campo vazio abre as sugestões, não navega.
      if (!inM.value.trim()) { e.preventDefault(); inM.focus(); pintarM(); return; }
      guardar(inM.value);
    });

    boxM.addEventListener('click', function (e) {
      if (e.target.closest('[data-hsm-mais]')) {
        /* boxM É o próprio .hsm — querySelector('.hsm') só olha DESCENDENTES e devolvia
           null: TypeError silencioso e o "Ver mais" das buscas populares nunca expandia. */
        boxM.classList.toggle('is-mais');
        return;
      }
      var it = e.target.closest('[data-q]');
      if (it) guardar(it.getAttribute('data-q'));
    });

    // o painel abre pelo botão da lupa (que o tema já controla); pinta ao abrir
    /* Trava a rolagem só com `busca-aberta` (overflow:hidden), IGUAL ao menu. O `height:100%`
       que existia aqui fazia o Chromium ZERAR o scroll ao abrir a busca — você caía no topo e,
       ao rolar de novo, o header e a barra de filtros da coleção ficavam dessincronizados
       ("barra distante do header"). Removido o height:100% no CSS, o scroll é preservado
       sozinho e não precisa salvar/restaurar (Will 23/Jul). */
    var trancar = function (on) {
      document.documentElement.classList.toggle('busca-aberta', on);
      document.body.classList.toggle('busca-aberta', on);
    };
    var lupaM = document.querySelector('[data-search-toggle]');
    if (lupaM) lupaM.addEventListener('click', function () {
      setTimeout(function () { trancar(painel.classList.contains('is-open')); pintarM(); }, 30);
    });
    /* Fecha a busca por completo, sem depender do scripts.js compilado (que cacheia
       separado e mais forte). Antes, este handler só destravava a rolagem e QUEM
       escondia o painel era o compilado — se ele estava velho, o Cancelar "não fazia
       nada" (destravava mas o painel continuava na tela). Agora fecha aqui mesmo. */
    var fecharBuscaM = function () {
      painel.classList.remove('is-open');
      trancar(false);
    };
    var fecharesM = painel.querySelectorAll('[data-search-close]'); /* setinha E "Cancelar" */
    fecharesM.forEach(function (btn) {
      btn.addEventListener('click', function () { setTimeout(fecharBuscaM, 30); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && painel.classList.contains('is-open')) fecharBuscaM();
    });
    pintarM();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porao-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var variantsJson = document.getElementById('pdp-variants-json');
  if (!variantsJson) return;

  var variants = JSON.parse(variantsJson.textContent);
  var container = document.querySelector('.pdp');
  if (!container) return;

  var mediaCount = container.querySelectorAll('.pdp__slide').length;

  var state = {
    option1: null,
    option2: null
  };

  // Init from current selected
  var selectedMoldura = container.querySelector('.pdp__moldura-card--selected');
  var selectedSize = container.querySelector('.pdp__size-btn--selected');
  if (selectedMoldura) state.option1 = selectedMoldura.dataset.value;
  if (selectedSize) state.option2 = selectedSize.dataset.value;

  // Elements
  var priceEl = document.getElementById('pdp-price');
  var comparePriceEl = document.getElementById('pdp-compare-price');
  var installmentEl = document.getElementById('pdp-installment-value');
  var variantIdInput = document.getElementById('pdp-variant-id');
  var addBtn = document.getElementById('pdp-add-btn');
  var option1Label = document.getElementById('pdp-option1-selected');
  var option2Label = document.getElementById('pdp-option2-selected');
  var scaleSizeLabel = document.getElementById('pdp-scale-size');
  var carousel = document.getElementById('pdp-carousel');
  var counterEl = document.getElementById('pdp-counter');
  var pixPriceEl = document.getElementById('pdp-pix-price');
  // bugfix 28/08 (achado #18a): o rótulo do Pix vem do setting pix_discount_label (renderizado
  // pelo Liquid) — capturado UMA vez aqui, antes do 1º updatePrice, tirando o que vem depois do
  // valor "R$ …". Antes o updatePrice concatenava ' no Pix' fixo e desfazia o painel no boot.
  var pixLabel = 'no Pix';
  if (pixPriceEl) {
    var _pl = pixPriceEl.textContent.trim().replace(/^R\$\s*[\d.,]+\s*/, '').trim();
    if (_pl) pixLabel = _pl;
  }

  // Decoupled Hero (LCP target). Hero <img> renderizada estaticamente fora do carousel,
  // sobreposta via position:absolute. Ao primeiro touch/scroll, hero some via opacity:0
  // pointer-events:none e carousel assume controle.
  var mediaStage = document.getElementById('pdp-media-stage');
  var heroImg = document.getElementById('pdp-hero-img');
  var engaged = false;

  function engage() {
    if (engaged || !mediaStage) return;
    engaged = true;
    mediaStage.classList.add('is-engaged');
  }

  // Listeners: qualquer interacao real do user no carousel -> engage
  if (carousel) {
    // bugfix 28/08 (achado #2): sem once:true — scrollToMedia(0)/swapMainImage desengatam (hero
    // volta) e os listeners consumidos deixavam o engate MORTO em definitivo; engage() já é
    // idempotente (early-return no flag), então o custo de manter os listeners é zero.
    ['touchstart','pointerdown','wheel'].forEach(function(evt) {
      carousel.addEventListener(evt, engage, { passive: true });
    });
    // bugfix 28/08 (achado #2): desktop — o zoom (.pdp__image-zoom:hover) age no carrossel SOB a
    // hero opaca; o 1º hover engata pra ele aparecer (a hero é pointer-events:none, o mouse passa).
    if (matchMedia('(min-width: 990px) and (hover: hover)').matches) {
      carousel.addEventListener('mousemove', engage, { passive: true });
    }
    // scroll programatico ou natural tambem engata
    carousel.addEventListener('scroll', function() {
      if (carousel.scrollLeft > 10) engage();
    }, { passive: true });
  }
  // Tap direto no hero tambem engata
  if (heroImg) {
    heroImg.addEventListener('pointerdown', engage, { once: true, passive: true });
  }

  function findVariant(o1, o2) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === o1 && variants[i].option2 === o2) {
        return variants[i];
      }
    }
    return null;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updatePrice(variant) {
    if (!variant) return;

    priceEl.classList.add('pdp__price--updating');
    setTimeout(function() {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.dataset.price = variant.price;

      if (variant.compare_at_price > variant.price) {
        if (!comparePriceEl) {
          var span = document.createElement('span');
          span.className = 'pdp__compare-price';
          span.id = 'pdp-compare-price';
          priceEl.parentNode.appendChild(span);
          comparePriceEl = span;
        }
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else if (comparePriceEl) {
        comparePriceEl.style.display = 'none';
      }

      if (installmentEl) {
        installmentEl.textContent = formatMoney(Math.round(variant.price / 12));
      }

      // Pix price (% vem do data-pix-pct, configurado no painel)
      if (pixPriceEl) {
        var pixWrap = document.getElementById('pdp-pix');
        var pixPct = pixWrap ? (parseFloat(pixWrap.dataset.pixPct) || 10) : 10;
        var pixPrice = Math.round(variant.price * (100 - pixPct) / 100);
        // bugfix 28/08 (achado #18a): usa o pixLabel capturado no boot (setting do painel) — era ' no Pix' fixo
        pixPriceEl.textContent = formatMoney(pixPrice) + ' ' + pixLabel;
      }

      priceEl.classList.remove('pdp__price--updating');
    }, 100);

    /* bugfix 28/08 (achado #18d): a escrita em #sticky-price saiu — o elemento foi removido do
       sticky em 22/07 e a referência ficou morta (getElementById nulo a cada troca de preço). */

  }

  /* A copy do botão é a do HTML, não uma string aqui. Antes o Liquid renderizava
     "ADICIONAR AO CARRINHO" e o boot trocava por "QUERO ESTE QUADRO" — dava pra ver a troca
     no botão de compra a cada PDP, e qualquer teste de copy feito no Liquid era desfeito
     em silêncio pelo JS. Guardamos o rótulo original e voltamos pra ele. */
  var ctaLabelOriginal = (addBtn && addBtn.textContent.trim()) || 'COMPRAR';
  function updateAvailability(variant) {
    if (!variant || !variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'INDISPONÍVEL';
    } else {
      addBtn.disabled = false;
      addBtn.textContent = ctaLabelOriginal;
    }
  }

  function updateSizeAvailability() {
    var sizeBtns = container.querySelectorAll('.pdp__size-btn');
    sizeBtns.forEach(function(btn) {
      var sizeVal = btn.dataset.value;
      var v = findVariant(state.option1, sizeVal);
      btn.classList.toggle('pdp__size-btn--unavailable', !v || !v.available);
      if (!v || !v.available) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function updateCounter(index) {
    if (counterEl && mediaCount > 0) {
      counterEl.textContent = (index + 1) + '/' + mediaCount;
    }
  }

  function scrollToMedia(mediaId) {
    if (!mediaId || !carousel) return;
    var slide = carousel.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;

    var index = parseInt(slide.dataset.index);
    carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });

    // Se for slide 0 e a hero ainda esta engatada, atualiza a hero pra essa media
    if (index === 0 && heroImg && mediaStage) {
      var slideImg = slide.querySelector('img');
      if (slideImg) {
        heroImg.src = slideImg.src;
        heroImg.srcset = slideImg.srcset || '';
        heroImg.alt = slideImg.alt || '';
        heroImg.setAttribute('data-media-id', String(mediaId));
      }
      // Quando o user volta pro slide 0, hero pode voltar a ser visivel
      mediaStage.classList.remove('is-engaged');
      engaged = false;
    } else if (index > 0) {
      engage();
    }

    // Update desktop thumbs
    var thumbs = container.querySelectorAll('.pdp__thumb');
    thumbs.forEach(function(t) {
      t.classList.toggle('pdp__thumb--active', t.dataset.mediaId === String(mediaId));
    });

    // Update dots
    var dots = container.querySelectorAll('.pdp__dot');
    dots.forEach(function(d) {
      d.classList.toggle('pdp__dot--active', parseInt(d.dataset.index) === index);
    });

    updateCounter(index);
  }

  function updateURL(variantId) {
    if (!variantId || !window.history.replaceState) return;
    var url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  function scrollToSlide(index) {
    if (!carousel) return;
    var slide = carousel.children[index];
    if (!slide) return;
    carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });

    var thumbs = container.querySelectorAll('.pdp__thumb');
    thumbs.forEach(function(t) { t.classList.toggle('pdp__thumb--active', parseInt(t.dataset.index) === index); });

    var dots = container.querySelectorAll('.pdp__dot');
    dots.forEach(function(d) { d.classList.toggle('pdp__dot--active', parseInt(d.dataset.index) === index); });

    updateCounter(index);
  }

  // Store original first slide image data so we can restore it
  var originalFirstSlideData = null;
  var originalHeroData = null;
  (function() {
    var firstSlide = carousel ? carousel.children[0] : null;
    if (firstSlide) {
      var img = firstSlide.querySelector('img');
      if (img) {
        originalFirstSlideData = { src: img.src, srcset: img.srcset };
      }
    }
    if (heroImg) {
      originalHeroData = { src: heroImg.src, srcset: heroImg.srcset };
    }
  })();

  function restoreFirstSlide() {
    if (originalFirstSlideData && carousel) {
      var firstSlide = carousel.children[0];
      if (firstSlide) {
        var img = firstSlide.querySelector('img');
        if (img) {
          img.src = originalFirstSlideData.src;
          img.srcset = originalFirstSlideData.srcset;
        }
      }
    }
    if (originalHeroData && heroImg) {
      heroImg.src = originalHeroData.src;
      heroImg.srcset = originalHeroData.srcset;
    }
  }

  function swapMainImage(imageUrl) {
    if (!imageUrl) return;
    // Atualiza a HERO image (em vez do slide 0 do carousel)
    if (heroImg) {
      heroImg.src = imageUrl;
      if (imageUrl.indexOf('width=') !== -1) {
        heroImg.srcset = imageUrl.replace(/width=\d+/, 'width=375') + ' 375w, ' +
                         imageUrl.replace(/width=\d+/, 'width=550') + ' 550w, ' +
                         imageUrl.replace(/width=\d+/, 'width=750') + ' 750w, ' +
                         imageUrl.replace(/width=\d+/, 'width=1100') + ' 1100w, ' +
                         imageUrl.replace(/width=\d+/, 'width=1500') + ' 1500w';
      } else {
        heroImg.srcset = '';
      }
    }
    // Tambem atualiza o slide 0 do carousel (pra ficar consistente quando engatar)
    if (carousel) {
      var firstSlide = carousel.children[0];
      if (firstSlide) {
        var img = firstSlide.querySelector('img');
        if (img) {
          img.src = imageUrl;
          if (imageUrl.indexOf('width=') !== -1) {
            img.srcset = imageUrl.replace(/width=\d+/, 'width=375') + ' 375w, ' +
                         imageUrl.replace(/width=\d+/, 'width=550') + ' 550w, ' +
                         imageUrl.replace(/width=\d+/, 'width=750') + ' 750w, ' +
                         imageUrl.replace(/width=\d+/, 'width=1100') + ' 1100w, ' +
                         imageUrl.replace(/width=\d+/, 'width=1500') + ' 1500w';
          } else {
            img.srcset = '';
          }
        }
      }
    }
    // Hero deve estar visivel apos variant change para sem-featured_media
    if (mediaStage) {
      mediaStage.classList.remove('is-engaged');
      engaged = false;
    }
    scrollToSlide(0);
  }

  function onOptionChange() {
    var variant = findVariant(state.option1, state.option2);
    if (variant) {
      variantIdInput.value = variant.id;
      updatePrice(variant);
      updateAvailability(variant);
      updateURL(variant.id);
      if (variant.featured_media_id) {
        // Variant has an associated product media — restore first slide if swapped, then scroll
        restoreFirstSlide();
        scrollToMedia(variant.featured_media_id);
      } else if (variant.featured_image) {
        // Variant has a CDN image but not in product.media — swap the main image src
        swapMainImage(variant.featured_image);
      }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'INDISPONÍVEL';
    }
    updateSizeAvailability();
  }

  /* Pre-carrega (silencioso, on idle) as 5 guias de tamanho da moldura atual -> clique instantaneo */
  var _tiPreloaded = {};
  function preloadTamanhos() {
    if (!heroImg) return;
    var sz = heroImg.getAttribute('sizes') || '';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === state.option1 && v.tamanho_image && !_tiPreloaded[v.tamanho_image]) {
        _tiPreloaded[v.tamanho_image] = 1;
        var im = new Image(); if (sz) im.sizes = sz;
        var u = v.tamanho_image;
        if (u.indexOf('width=') !== -1) {
          im.srcset = [375, 550, 750, 1100, 1500].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
        }
        im.src = u;
      }
    }
  }
  function preloadIdle() { if ('requestIdleCallback' in window) { requestIdleCallback(preloadTamanhos, { timeout: 2500 }); } else { setTimeout(preloadTamanhos, 800); } }

  // Helper: drag-to-scroll horizontal (desktop). Listeners no document só durante drag.
  // 22/Jul (Will: "delayzinho"): o snap x mandatory ficava LIGADO durante o arrasto e
  // quantizava o movimento (só andava quando o mouse chegava no card seguinte). Agora o
  // snap desliga no aperto e volta quando a inércia termina — arrasto 1:1 igual à home.
  function bindDragScroll(el) {
    // matchMedia nao forca layout (innerWidth no parse forcava — 17ms no trace 27/07)
    if (!el || !window.matchMedia('(min-width: 990px)').matches) return;
    var isDown = false, startX = 0, scrollLeft = 0, moved = false, vel = 0, ultX = 0, ultT = 0, inercia = null;
    function onMove(e) {
      if (!isDown) return;
      var walk = e.pageX - startX;
      if (Math.abs(walk) > 5) moved = true;
      var tt = Date.now(), dt = tt - ultT;
      if (dt > 0) { vel = (e.pageX - ultX) / dt; ultX = e.pageX; ultT = tt; }
      el.scrollLeft = scrollLeft - walk;
    }
    function onUp() {
      if (!isDown) return;
      isDown = false;
      el.style.cursor = '';
      el.style.userSelect = '';
      document.removeEventListener('mousemove', onMove);
      setTimeout(function() { moved = false; }, 50);
      /* inércia (padrão da home); o snap só volta no fim, senão engoliria o deslize */
      var v = vel * 15;
      (function passo() {
        if (Math.abs(v) < 0.25) { el.style.scrollSnapType = ''; inercia = null; return; }
        el.scrollLeft -= v; v *= 0.945; inercia = requestAnimationFrame(passo);
      })();
    }
    el.addEventListener('dragstart', function(e) { e.preventDefault(); });
    el.addEventListener('mousedown', function(e) {
      if (inercia) { cancelAnimationFrame(inercia); inercia = null; }
      isDown = true;
      moved = false;
      startX = e.pageX;
      scrollLeft = el.scrollLeft;
      ultX = e.pageX; ultT = Date.now(); vel = 0;
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
      el.style.scrollSnapType = 'none';
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp, { once: true });
      e.preventDefault();
    });
    el.addEventListener('click', function(e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  }
  bindDragScroll(container.querySelector('.pdp__moldura-carousel'));
  bindDragScroll(document.getElementById('pdp-recommendations'));

  // ===== Netflix effect: center selected item in carousel =====
  function centerInCarousel(item, carousel) {
    if (!item || !carousel) return;
    var carouselRect = carousel.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var carouselCenter = carouselRect.width / 2;
    var itemCenter = (itemRect.left - carouselRect.left) + carousel.scrollLeft + (itemRect.width / 2);
    var targetScroll = itemCenter - carouselCenter;
    // Clamp to valid scroll range
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
    carousel.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  var molduraCarousel = container.querySelector('.pdp__moldura-carousel');
  var sizeCarousel = container.querySelector('.pdp__size-carousel');

  // Start at 0 (first item fully visible) — adiado 2 frames: escrever scrollLeft no parse
  // exige layout pra clampar e forcava reflow (28ms no trace 27/07)
  requestAnimationFrame(function(){ requestAnimationFrame(function(){
    if (molduraCarousel) molduraCarousel.scrollLeft = 0;
    if (sizeCarousel) sizeCarousel.scrollLeft = 0;
  }); });

  // FASE 7: REMOVIDO bounceHint - causava CLS 0.072 (layout shift involuntario detectado pelo Lighthouse).
  // Sinalização de carrossel agora apenas via setas \"hint\" laterais (CSS é composto, não causa CLS).

  // Hide/show scroll hints based on scroll position (both sides)
  function setupScrollHints(carousel, leftHintId, rightHintId) {
    var hintLeft = document.getElementById(leftHintId);
    var hintRight = document.getElementById(rightHintId);
    if (!carousel || !hintLeft || !hintRight) return;

    function updateHints() {
      var noScroll = carousel.scrollWidth <= carousel.clientWidth + 2;
      var atStart = carousel.scrollLeft <= 5;
      var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 5;

      // Sem overflow: nenhum chevron (nao ha mais conteudo pros lados)
      if (noScroll) {
        hintLeft.classList.add('pdp__scroll-hint--hidden');
        hintRight.classList.add('pdp__scroll-hint--hidden');
        return;
      }

      // Ha overflow: AMBOS sempre visiveis. O que esta na ponta fica esmaecido
      // (opacity reduzida + nao clicavel), igual as setas da galeria principal.
      hintLeft.classList.remove('pdp__scroll-hint--hidden');
      hintRight.classList.remove('pdp__scroll-hint--hidden');
      hintLeft.classList.toggle('pdp__scroll-hint--dimmed', atStart);
      hintRight.classList.toggle('pdp__scroll-hint--dimmed', atEnd);
    }

    carousel.addEventListener('scroll', updateHints, { passive: true });
    // Chevrons clicaveis: rolam ~80% da largura visivel
    function step(){ return Math.round(carousel.clientWidth * 0.8); }
    hintRight.addEventListener('click', function(){ carousel.scrollBy({ left: step(), behavior: 'smooth' }); });
    hintLeft.addEventListener('click', function(){ carousel.scrollBy({ left: -step(), behavior: 'smooth' }); });
    // Run once on init
    // estado inicial 2 frames depois (le scrollWidth — no parse forcava reflow)
    requestAnimationFrame(function(){ requestAnimationFrame(updateHints); });
  }

  setupScrollHints(molduraCarousel, 'pdp-moldura-hint-left', 'pdp-moldura-hint-right');
  setupScrollHints(sizeCarousel, 'pdp-size-hint-left', 'pdp-size-hint-right');

  /* Handler dos "value badge tooltips" apagado em 21/07 junto com o ticker e os 3 tooltips
     (decisão do Will) — o gatilho .pdp__value-badge nunca existiu em markup nenhum. */

  // Ancora no menor preço (1ª moldura + 1º tamanho) — MAS só quando a pessoa chegou sem
  // pedir variante. Quem chega por ?variant= (anúncio do Google Shopping por variante, link
  // que o próprio site manda no botão de WhatsApp, link salvo) tem que ver EXATAMENTE a
  // variante do link. Antes o boot sobrescrevia tudo e ainda reescrevia a URL: um link de
  // R$ 1.062,54 (Preta/150x100) abria em R$ 687,00 (Borda Infinita/100x65). Medido em 21/07.
  var allMolduras = container.querySelectorAll('.pdp__moldura-card');
  var allSizes = container.querySelectorAll('.pdp__size-btn');

  var idPedido = null;
  try { idPedido = new URLSearchParams(location.search).get('variant'); } catch (e) {}
  var vPedida = null;
  if (idPedido) {
    for (var vi = 0; vi < variants.length; vi++) {
      if (String(variants[vi].id) === String(idPedido)) { vPedida = variants[vi]; break; }
    }
  }
  // bugfix 28/08 (achados #1/#25): sem ?variant, ancora no VALOR ATUAL do hidden — honra a
  // escolha pré-boot do micro-script inline (que só grava match disponível) e o
  // first-available do Liquid. Antes re-ancorava incondicional na 1ª moldura + 1º tamanho e
  // desfazia diante do cliente a escolha que o inline acabara de confirmar.
  if (!vPedida && variantIdInput && variantIdInput.value) {
    for (var vj = 0; vj < variants.length; vj++) {
      if (String(variants[vj].id) === String(variantIdInput.value)) { vPedida = variants[vj]; break; }
    }
  }

  function marcar(lista, classe, valor) {
    var achou = null;
    lista.forEach(function(el) {
      var eh = valor != null && el.dataset.value === valor;
      el.classList.toggle(classe, eh);
      el.setAttribute('aria-pressed', eh ? 'true' : 'false');
      if (eh) achou = el;
    });
    return achou;
  }

  if (allMolduras.length > 0) {
    var alvo1 = vPedida ? vPedida.option1 : allMolduras[0].dataset.value;
    if (!marcar(allMolduras, 'pdp__moldura-card--selected', alvo1)) {
      alvo1 = allMolduras[0].dataset.value;
      marcar(allMolduras, 'pdp__moldura-card--selected', alvo1);
    }
    state.option1 = alvo1;
    if (option1Label) option1Label.textContent = state.option1;
  }

  if (allSizes.length > 0) {
    var alvo2 = vPedida ? vPedida.option2 : allSizes[0].dataset.value;
    if (!marcar(allSizes, 'pdp__size-btn--selected', alvo2)) {
      alvo2 = allSizes[0].dataset.value;
      marcar(allSizes, 'pdp__size-btn--selected', alvo2);
    }
    state.option2 = alvo2;
    if (option2Label) option2Label.textContent = state.option2;
    if (scaleSizeLabel) scaleSizeLabel.textContent = state.option2;
  }

  // Update variant/price to match first options
  onOptionChange();
  /* Pré-carga inicial das guias SÓ 3,5s depois do load (24/07): com rIC(2500) as 5 guias
     (~270KB) entravam a 1,2s e roubavam banda do LCP (Lighthouse). Na troca de moldura
     (interação) continua imediata — lá o usuário já está mexendo. */
  (function () {
    var arma = function () { setTimeout(preloadIdle, 3500); };
    if (document.readyState === 'complete') arma();
    else window.addEventListener('load', arma, { once: true });
  })();

  // Event delegation
  container.addEventListener('click', function(e) {
    var molduraCard = e.target.closest('.pdp__moldura-card');
    var sizeBtn = e.target.closest('.pdp__size-btn');
    var thumb = e.target.closest('.pdp__thumb');
    var dot = e.target.closest('.pdp__dot');

    if (molduraCard) {
      container.querySelectorAll('.pdp__moldura-card').forEach(function(c) {
        c.classList.remove('pdp__moldura-card--selected');
        c.setAttribute('aria-pressed', 'false');
      });
      molduraCard.classList.add('pdp__moldura-card--selected');
      molduraCard.setAttribute('aria-pressed', 'true');
      state.option1 = molduraCard.dataset.value;
      if (option1Label) option1Label.textContent = state.option1;

      /* Center selected moldura in carousel */
      centerInCarousel(molduraCard, molduraCarousel);

      /* Swap main image from data-variant-image on the card */
      var cardImage = molduraCard.dataset.variantImage;
      if (cardImage) {
        swapMainImage(cardImage);
      }

      onOptionChange();
      preloadIdle();
      return;
    }

    if (sizeBtn) {
      if (sizeBtn.classList.contains('pdp__size-btn--unavailable')) return;
      container.querySelectorAll('.pdp__size-btn').forEach(function(b) {
        b.classList.remove('pdp__size-btn--selected');
        b.setAttribute('aria-pressed', 'false');
      });
      sizeBtn.classList.add('pdp__size-btn--selected');
      sizeBtn.setAttribute('aria-pressed', 'true');
      state.option2 = sizeBtn.dataset.value;
      if (option2Label) option2Label.textContent = state.option2;
      if (scaleSizeLabel) scaleSizeLabel.textContent = state.option2;

      /* Center selected size in carousel */
      centerInCarousel(sizeBtn, sizeCarousel);
      onOptionChange();
      /* Guia de tamanho: mostra a imagem-proporcao da variante (moldura+tamanho) atual */
      var _gv = findVariant(state.option1, state.option2);
      if (_gv && _gv.tamanho_image) { swapMainImage(_gv.tamanho_image); }
      return;
    }

    if (thumb) {
      // Restaura a foto original do produto (slide 0 + hero) que pode ter sido
      // sobreposta por uma variante de moldura, antes de navegar pela galeria.
      restoreFirstSlide();
      scrollToMedia(thumb.dataset.mediaId);
      return;
    }

    if (dot) {
      restoreFirstSlide();
      var idx = parseInt(dot.dataset.index);
      var targetSlide = carousel.children[idx];
      if (targetSlide) {
        if (idx > 0 && !engaged) { engage(); }
        carousel.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      }
      return;
    }
  });

  // Carousel scroll => update dots + counter + thumbs
  if (carousel) {
    var scrollTimer;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var scrollLeft = carousel.scrollLeft;
        var slideWidth = carousel.offsetWidth;
        var index = Math.round(scrollLeft / slideWidth);

        var dots = container.querySelectorAll('.pdp__dot');
        dots.forEach(function(d) {
          d.classList.toggle('pdp__dot--active', parseInt(d.dataset.index) === index);
        });

        var thumbs = container.querySelectorAll('.pdp__thumb');
        if (thumbs[index]) {
          thumbs.forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
          thumbs[index].classList.add('pdp__thumb--active');
        }

        updateCounter(index);
      }, 50);
    });
  }

  // Desktop zoom follow mouse — rAF throttle, listener só nos slides
  if (matchMedia('(min-width: 990px) and (hover: hover)').matches) {
    var zoomRaf = 0;
    var pendingEvent = null;
    function applyZoom() {
      zoomRaf = 0;
      var e = pendingEvent;
      if (!e) return;
      var zoomWrap = e.target.closest('.pdp__image-zoom');
      if (!zoomWrap) return;
      var rect = zoomWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width * 100) + '%';
      var y = ((e.clientY - rect.top) / rect.height * 100) + '%';
      zoomWrap.style.setProperty('--zoom-x', x);
      zoomWrap.style.setProperty('--zoom-y', y);
    }
    container.addEventListener('mousemove', function(e) {
      pendingEvent = e;
      if (!zoomRaf) zoomRaf = requestAnimationFrame(applyZoom);
    }, { passive: true });
  }

  /* Sistema ANTIGO de CEP/add-more apagado em 21/07: #pdp-add-more-btn, #pdp-cep-btn e
     #pdp-shipping-result não existem em nenhum markup (0 ocorrências no HTML renderizado),
     e a MÁSCARA antiga ainda ligava — o campo #pdp-cep-input ficava com DOIS listeners de
     input reescrevendo o value a cada tecla (o sistema vivo, mais abaixo, já faz máscara + ETA). */

  // Load recommendations via API — deferred ate IntersectionObserver detectar
  // proximidade da section pdp-related (~300px de margem). Reduz carga no critical path.
  var recContainer = document.getElementById('pdp-recommendations');
  var productId = container.dataset.productId;
  var recSection = document.getElementById('pdp-related');
  // bugfix 28/08 (achado #18b): quantidade vem do painel (data-rec-count no #pdp-related) — era 8 fixo
  var recCount = parseInt((recSection && recSection.dataset.recCount) || '8', 10) || 8;
  var recLoaded = false;
  // Qual pílula de filtro está ativa. Declarada AQUI porque a busca dos "parecidos" é
  // assíncrona: se o usuário clicar numa pílula enquanto ela ainda está voando, a resposta
  // chegaria depois e sobrescreveria os cards do filtro. As duas funções abaixo checam isso.
  var pillAtual = 'rec';

  // Favoritos: monta card relacionado (stretched-link + coração) igual ao snippet product-card
  function wlEsc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function wlRecCard(it, imgSrc, linkHref){
    var sep = it.image && it.image.indexOf('?')!==-1 ? '&' : '?';
    var img400 = it.image ? it.image + sep + 'width=400&format=webp' : '';
    return '<div class="product-card">' +
      '<div class="product-card__image-wrap">' +
        (imgSrc ? '<img class="product-card__image--primary" src="' + imgSrc + '" alt="' + wlEsc(it.title) + '" loading="lazy" width="320" height="320" decoding="async">' : '') +
        '<button type="button" class="wishlist-btn wishlist-btn--card" data-wishlist-toggle aria-pressed="false" aria-label="Adicionar aos favoritos"' +
          ' data-id="' + wlEsc(it.id) + '" data-handle="' + wlEsc(it.handle) + '" data-title="' + wlEsc(it.title) + '"' +
          ' data-image="' + wlEsc(img400) + '" data-price="' + wlEsc(it.price) + '" data-url="' + wlEsc('/products/' + it.handle) + '">' +
          '<svg width="20" height="20" class="wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
        '</button>' +
      '</div>' +
      /* 07/09: os DOIS nomes, igual ao `snippets/product-card.liquid` (nome inteiro + nome sem o
         "Quadro Decorativo " da frente). Este card é montado aqui em JS, não pelo snippet, então
         era o único lugar do site que não tinha o par — e por isso a regra do nome curto da prévia
         não pegava nos relacionados da PDP.
         ⚠️ ADITIVO: o `.pc-t-clean` nasce com `display:none` inline e o CSS global esconde ele de
         novo, então PRA CLIENTE não muda absolutamente nada — continua o nome inteiro. Quem troca
         é a regra `html.previa` do `snippets/previa.liquid`. */
      '<h3 class="product-card__title"><span class="pc-t-full">' + wlEsc(it.title) + '</span>' +
        '<span class="pc-t-clean" style="display:none">' +
        wlEsc(String(it.title == null ? '' : it.title).replace(/^Quadro Decorativo Grande (.+) para (?:Sala|Quarto|Escritório|Área Gourmet|Banheiro)(?: .*)?$/, '$1').replace(/^Quadro Decorativo /, '')) + /* 25/09: mesma regra do nome curto do product-card.liquid */
        '</span></h3>' +
      '<a href="' + wlEsc(linkHref) + '" class="product-card__link" aria-label="' + wlEsc(it.title) + '"></a>' +
    '</div>';
  }

  /* 25/09 — "Parecidos" calculados pela Organização do Ateliê (metacampo
     custom.produtos_parecidos, renderizado pelo Liquid em #pdp-parecidos-json). Nasceu só na
     prévia; GLOBAL desde 25/09 à noite (Will: "deixe na prévia, mas já pode aplicar no site
     também") — o teste de html.previa/previa-desk saiu. Lista curta (< 4) ou ausente → a
     Recommendations API da Shopify continua como reserva. */
  function wlSemLargura(u){ return String(u||'').replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, ''); }
  function montaParecidosDaLoja(){
    var el = document.getElementById('pdp-parecidos-json');
    if (!el) return false;
    var lista;
    try { lista = JSON.parse(el.textContent || '[]'); } catch (e) { return false; }
    if (!lista || lista.length < 4) return false;
    if (pillAtual !== 'rec') return true;
    recContainer.innerHTML = '';
    lista.slice(0, recCount).forEach(function(p){
      var base = wlSemLargura(p.image);
      var imgSrc = base ? base + (base.indexOf('?') !== -1 ? '&' : '?') + 'width=320&format=webp' : '';
      var card = document.createElement('div');
      card.className = 'carousel__item';
      card.innerHTML = wlRecCard({ id: p.id, handle: p.handle, title: p.title, image: base, price: p.price }, imgSrc, p.url);
      recContainer.appendChild(card);
    });
    if (window.PoraoWishlist) window.PoraoWishlist.sync();
    return true;
  }

  function fetchRecommendations() {
    if (recLoaded || !recContainer || !productId) return;
    recLoaded = true;
    if (montaParecidosDaLoja()) return;
    var recUrl = '/recommendations/products.json?product_id=' + productId + '&limit=' + recCount; // bugfix 28/08 (achado #18b)
    fetch(recUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (pillAtual !== 'rec') return;   // usuário já trocou de pílula: não sobrescrever
        if (data.products && data.products.length > 0) {
          recContainer.innerHTML = '';
          data.products.forEach(function(p) {
            var priceFormatted = formatMoney(p.price);
            var minPrice = p.price_min;
            var maxPrice = p.price_max;
            var priceLabel = minPrice !== maxPrice ? 'A partir de ' + formatMoney(minPrice) : priceFormatted;
            var imgSrc = '';
            if (p.featured_image) {
              var sep = p.featured_image.indexOf('?') !== -1 ? '&' : '?';
              imgSrc = p.featured_image + sep + 'width=320&format=webp';
            }
            var card = document.createElement('div');
            card.className = 'carousel__item';
            card.innerHTML = wlRecCard(
              { id: p.id, handle: p.handle, title: p.title, image: p.featured_image, price: p.price },
              imgSrc, p.url
            );
            recContainer.appendChild(card);
          });
          if (window.PoraoWishlist) window.PoraoWishlist.sync();
        } else {
          loadFallbackProducts();
        }
      })
      .catch(function() {
        loadFallbackProducts();
      });
  }

  if (recSection && recContainer && productId && 'IntersectionObserver' in window) {
    var recObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          fetchRecommendations();
          recObserver.disconnect();
        }
      });
    }, { rootMargin: '300px' });
    recObserver.observe(recSection);
  } else if (recContainer && productId) {
    // Fallback: dispara via requestIdleCallback se nao houver IO
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fetchRecommendations, { timeout: 3000 });
    } else {
      setTimeout(fetchRecommendations, 2000);
    }
  }

  function loadFallbackProducts() {
    if (!recContainer) return;
    fetch('/collections/all/products.json?limit=' + recCount) // bugfix 28/08 (achado #18b)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (pillAtual !== 'rec') return;   // usuário já trocou de pílula: não sobrescrever
        if (data.products && data.products.length > 0) {
          recContainer.innerHTML = '';
          data.products.forEach(function(p) {
            if (String(p.id) === productId) return;
            var raw = (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '';
            var imgSrc = '';
            if (raw) {
              var sep = raw.indexOf('?') !== -1 ? '&' : '?';
              imgSrc = raw + sep + 'width=320&format=webp';
            }
            var cents = (p.variants && p.variants[0]) ? Math.round(parseFloat(p.variants[0].price) * 100) : '';
            var card = document.createElement('div');
            card.className = 'carousel__item';
            card.innerHTML = wlRecCard(
              { id: p.id, handle: p.handle, title: p.title, image: raw, price: cents },
              imgSrc, '/products/' + p.handle
            );
            recContainer.appendChild(card);
          });
          if (window.PoraoWishlist) window.PoraoWishlist.sync();
        }
      })
      .catch(function() {});
  }

  // Ação rápida "carrinho" sobre a imagem — adiciona via AJAX, SEM sair da página.
  // Fica vermelho (igual ao coração) quando o produto está no carrinho + aviso flutuante.
  var qaCart = document.getElementById('pdp-qa-cart');
  if (qaCart) {
    // ATENÇÃO: este bloco é {% javascript %} — o Shopify NÃO processa Liquid aqui.
    // Nunca usar {{ ... }} dentro dele. O id vem do data-attribute já presente no DOM.
    var QA_PRODUCT_ID = Number((container && container.dataset.productId) || 0);

    function qaMarcar(noCarrinho) {
      qaCart.classList.toggle('is-active', !!noCarrinho);
      qaCart.setAttribute('aria-label', noCarrinho ? 'No carrinho — tocar para remover' : 'Adicionar ao carrinho');
      qaCart.setAttribute('aria-pressed', noCarrinho ? 'true' : 'false');
    }
    function qaBadge(n) {
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = n > 9 ? '9+' : String(n);
        if (n === 0) badges[i].setAttribute('hidden', ''); else badges[i].removeAttribute('hidden');
      }
    }
    // Estado inicial: já está no carrinho?
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        qaMarcar(c.items.some(function (i) { return i.product_id === QA_PRODUCT_ID; }));
      })
      .catch(function () {});

    /* LIGA/DESLIGA, igual ao coração (Will 22/Jul): tocar de novo TIRA do carrinho em vez de
       somar mais um. Some pelas LINHAS do produto (podem existir várias, uma por variante) —
       quantity:0 em cada `key` esvazia o produto inteiro, que é o que "sair do carrinho"
       significa pra quem olha o ícone. */
    function qaRemover() {
      qaCart.classList.add('is-loading');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var linhas = c.items.filter(function (i) { return i.product_id === QA_PRODUCT_ID; });
          if (!linhas.length) { qaMarcar(false); return null; }
          /* uma de cada vez: /cart/change.js reordena as linhas a cada chamada, então
             disparar tudo em paralelo removeria a linha errada */
          return linhas.reduce(function (fila, item) {
            return fila.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            });
          }, Promise.resolve());
        })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          qaBadge(c.item_count);
          qaMarcar(false);
          if (window.PoraoToast) window.PoraoToast('Removido do carrinho');
        })
        .catch(function () {
          if (window.PoraoToast) window.PoraoToast('Não consegui remover. Tente de novo.');
        })
        .then(function () { qaCart.classList.remove('is-loading'); });
    }

    function qaAdicionar() {
      var varInput = document.getElementById('pdp-variant-id');
      if (!varInput || !varInput.value) return;
      qaCart.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(varInput.value), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          qaBadge(c.item_count);
          qaMarcar(true);
          qaCart.classList.add('just-added');
          setTimeout(function () { qaCart.classList.remove('just-added'); }, 520);
          if (window.PoraoToast) window.PoraoToast('Adicionado ao carrinho', '/cart', 'Ver carrinho');
        })
        .catch(function () {
          if (window.PoraoToast) window.PoraoToast('Não consegui adicionar. Tente de novo.');
        })
        .then(function () { qaCart.classList.remove('is-loading'); });
    }

    qaCart.addEventListener('click', function () {
      if (qaCart.classList.contains('is-loading')) return;
      if (qaCart.classList.contains('is-active')) qaRemover(); else qaAdicionar();
    });
  }

  // Trilho de miniaturas (desktop): fade nas pontas só quando há mais foto,
  // e a trilha acompanha a foto ativa quando o usuário navega pelas setas.
  var thumbRail = container.querySelector('.pdp__thumbs');
  if (thumbRail) {
    function railFade() {
      var sobraCima = thumbRail.scrollTop;
      var sobraBaixo = thumbRail.scrollHeight - thumbRail.clientHeight - thumbRail.scrollTop;
      thumbRail.style.setProperty('--fade-t', sobraCima > 4 ? '26px' : '0px');
      thumbRail.style.setProperty('--fade-b', sobraBaixo > 4 ? '26px' : '0px');
    }
    // Altura da trilha = altura da foto principal. Alinha as duas colunas E aumenta o
    // espaço de rolagem (sem espaço sobrando, não existe deslize nenhum pra ver).
    var mainWrap = container.querySelector('.pdp__main-image-wrap');
    function railAplicaAltura(mh) {
      if (mh > 200) thumbRail.style.maxHeight = Math.round(mh) + 'px';
      requestAnimationFrame(railFade); // rail le scroll/altura no proximo frame, com layout limpo
    }
    function railAltura() {
      railAplicaAltura(mainWrap ? mainWrap.offsetHeight : 0);
    }
    thumbRail.addEventListener('scroll', railFade, { passive: true });
    window.addEventListener('resize', railAltura);
    if (mainWrap && 'ResizeObserver' in window) {
      /* altura vem do PROPRIO evento do RO — sem ler offsetHeight. Ler aqui custava 97ms:
         o RO do header escreve --header-spacer no mesmo lote e invalida o estilo da pagina
         inteira; a leitura pagava o layout todo de novo. */
      new ResizeObserver(function (en) {
        var bb = en[0].borderBoxSize;
        railAplicaAltura(bb && bb.length ? bb[0].blockSize : en[0].contentRect.height);
      }).observe(mainWrap);
    } else {
      railAltura();
    }

    // Centraliza a miniatura ativa sem rolar a PÁGINA (scrollIntoView rolaria a página junto).
    // Medimos por getBoundingClientRect: offsetTop NÃO serve aqui, porque .pdp__thumbs não é
    // position:relative — o offsetParent é a galeria (sticky) e a conta sairia errada.
    var railRaf = null;
    // Efeito "trilho" (Netflix): a miniatura ativa é sempre puxada pro CENTRO e o trilho
    // desliza junto a cada clique — não espera ela sair da vista pra reagir.
    // Trava nas pontas: no começo não sobe além do topo, no fim não passa do último.
    function railSeguirAtiva() {
      var ativa = thumbRail.querySelector('.pdp__thumb--active');
      if (!ativa) return;
      var a = ativa.getBoundingClientRect();
      var r = thumbRail.getBoundingClientRect();
      var alvo = thumbRail.scrollTop + (a.top - r.top) - (r.height - a.height) / 2;
      var max = thumbRail.scrollHeight - thumbRail.clientHeight;
      alvo = Math.max(0, Math.min(alvo, max));
      if (Math.abs(alvo - thumbRail.scrollTop) > 1) thumbRail.scrollTop = alvo;
    }
    var railObs = new MutationObserver(function () {
      if (railRaf) return;
      railRaf = requestAnimationFrame(function () { railRaf = null; railSeguirAtiva(); });
    });
    railObs.observe(thumbRail, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ===== Pílulas de filtro da "Nossa Coleção" (Will, 13/Jul) =====
     LEVEZA — as três decisões que importam:
     1) Nada é buscado no carregamento da página. Só ao CLICAR numa pílula.
     2) Busca o HTML JÁ PRONTO dos cards (template collection.cards, sem layout: ~12KB),
        em vez de /collections/x/products.json, que traria o body_html inteiro (~200KB).
     3) Cache em memória: clicar de novo na mesma pílula é instantâneo, sem rede.
     As setas do carrossel se reajustam sozinhas (já existe um MutationObserver nele). */
  var pills = document.querySelectorAll('[data-pill]');
  if (pills.length && recContainer) {
    var cachePill = {};
    var carregandoPill = false;

    function aplicarCards(html) {
      recContainer.innerHTML = html;
      recContainer.scrollLeft = 0;
      /* repinta os corações de favorito nos cards novos */
      if (window.PoraoWishlist) window.PoraoWishlist.sync();
    }

    function marcarPill(btn) {
      for (var m = 0; m < pills.length; m++) {
        var on = pills[m] === btn;
        pills[m].classList.toggle('is-active', on);
        pills[m].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    for (var pi = 0; pi < pills.length; pi++) {
      pills[pi].addEventListener('click', function () {
        var alvo = this.getAttribute('data-pill');
        if (carregandoPill || alvo === pillAtual) return;

        /* guarda os "Parecidos" antes de sair deles — voltar é instantâneo */
        if (pillAtual === 'rec' && !cachePill.rec) cachePill.rec = recContainer.innerHTML;

        marcarPill(this);
        pillAtual = alvo;

        if (cachePill[alvo]) { aplicarCards(cachePill[alvo]); return; }

        carregandoPill = true;
        recContainer.classList.add('is-loading');
        fetch('/collections/' + alvo + '?view=cards', { headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
          .then(function (html) {
            cachePill[alvo] = html;
            if (pillAtual === alvo) aplicarCards(html);   // ainda é a pílula escolhida?
          })
          .catch(function () {
            if (pillAtual === alvo) {
              recContainer.innerHTML = '<p class="pdp__pill-erro">Não consegui carregar agora. Tente de novo.</p>';
            }
          })
          .then(function () {
            carregandoPill = false;
            recContainer.classList.remove('is-loading');
          });
      });
    }
  }

  // Init
  updateSizeAvailability();

  // Gallery arrows (desktop + mobile) — sempre visiveis, estilo Nossa Colecao (disabled nas pontas)
  var arrowLeft = document.getElementById('pdp-arrow-left');
  var arrowRight = document.getElementById('pdp-arrow-right');
  if (carousel && arrowLeft && arrowRight) {
    var isDesktopGallery = function(){ return matchMedia('(min-width: 990px)').matches; };

    function galCurrentIndex() {
      // Desktop: carousel nao rola (overflow hidden) -> indice vem da thumb ativa / hero
      if (isDesktopGallery()) {
        var activeThumb = container.querySelector('.pdp__thumb--active');
        if (activeThumb) return parseInt(activeThumb.dataset.index) || 0;
        return engaged ? 0 : 0;
      }
      var sw = carousel.querySelector('.pdp__slide');
      sw = sw ? sw.offsetWidth : carousel.clientWidth;
      return Math.round(carousel.scrollLeft / sw);
    }
    function galUpdate() {
      var idx = galCurrentIndex();
      arrowLeft.disabled = (idx <= 0);
      arrowRight.disabled = (idx >= mediaCount - 1);
    }
    function galGoTo(idx) {
      if (idx < 0 || idx > mediaCount - 1) return;
      // Sempre restaura a foto original (caso variante tenha sobreposto) antes de navegar pela galeria
      restoreFirstSlide();
      if (idx > 0 && !engaged) { engage(); }
      else if (idx === 0) { if (mediaStage) { mediaStage.classList.remove('is-engaged'); } engaged = false; }
      var slide = carousel.children[idx];
      if (slide) carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      // sincroniza thumbs/dots/counter
      var thumbs = container.querySelectorAll('.pdp__thumb');
      thumbs.forEach(function(t){ t.classList.toggle('pdp__thumb--active', parseInt(t.dataset.index) === idx); });
      var dots = container.querySelectorAll('.pdp__dot');
      dots.forEach(function(d){ d.classList.toggle('pdp__dot--active', parseInt(d.dataset.index) === idx); });
      updateCounter(idx);
      galUpdate();
    }
    arrowRight.addEventListener('click', function(){ galGoTo(galCurrentIndex() + 1); });
    arrowLeft.addEventListener('click', function(){ galGoTo(galCurrentIndex() - 1); });
    carousel.addEventListener('scroll', galUpdate, { passive: true });
    // estado inicial das setas 2 frames depois (galCurrentIndex le offsetWidth — reflow no parse)
    requestAnimationFrame(function(){ requestAnimationFrame(galUpdate); });
  }

  // ===== FEATURE 1: Lightbox — DISABLED on mobile, kept for desktop only =====

  // ===== Setas do carousel Nossa Colecao (displate style) =====
  (function(){
    var rel = document.getElementById('pdp-related');
    if (!rel) return;
    var car = rel.querySelector('#pdp-recommendations');
    var prev = rel.querySelector('#pdp-related-prev');
    var next = rel.querySelector('#pdp-related-next');
    if (!car || !prev || !next) return;

    // Setas sempre visiveis: remove hidden inicial e usa disabled em vez
    prev.hidden = false;
    next.hidden = false;

    function getStep(){
      var first = car.querySelector('.carousel__item');
      if (!first) return 320;
      var gap = parseFloat(getComputedStyle(car).gap) || 24;
      return first.getBoundingClientRect().width + gap;
    }
    function update(){
      // Batch reads antes dos writes (evita reflow)
      var sl = car.scrollLeft;
      var maxScroll = car.scrollWidth - car.clientWidth - 4;
      prev.disabled = (sl <= 4);
      next.disabled = (sl >= maxScroll);
    }
    prev.addEventListener('click', function(){ car.scrollBy({ left: -getStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function(){ car.scrollBy({ left:  getStep(), behavior: 'smooth' }); });
    car.addEventListener('scroll', update, { passive: true });
    // Atualiza apos cards carregarem via Recommendations API — 2 frames DEPOIS da insercao:
    // o MO dispara com o layout sujo e ler scrollWidth na hora pagava reflow (28ms no trace)
    var upPend = false;
    function agendaUpdate(){
      if (upPend) return; upPend = true;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ upPend = false; update(); }); });
    }
    var mo = new MutationObserver(agendaUpdate);
    mo.observe(car, { childList: true });
    agendaUpdate();
  })();

  // bugfix 28/08 (achado #16): feriados nacionais NÃO contam como dia útil — nem na produção,
  // nem no trânsito, nem no cutoff/urgência. Datas em America/Sao_Paulo (o código já converte).
  var FERIADOS_BR = ['2026-01-01','2026-02-16','2026-02-17','2026-04-03','2026-04-21','2026-05-01','2026-06-04','2026-09-07','2026-10-12','2026-11-02','2026-11-15','2026-11-20','2026-12-25','2027-01-01','2027-02-08','2027-02-09','2027-03-26','2027-04-21','2027-05-01','2027-05-27','2027-09-07','2027-10-12','2027-11-02','2027-11-15','2027-11-20','2027-12-25'];
  function ehFeriadoBR(d){
    var m = d.getMonth() + 1, dia = d.getDate();
    var iso = d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dia < 10 ? '0' : '') + dia;
    return FERIADOS_BR.indexOf(iso) !== -1;
  }

  // ===== Data de entrega estimada por CEP (tabela embutida, zero API) =====
  // Faixas: prefixo CEP 5 digitos [de, ate, prazo transportadora em dias uteis].
  // Prazo exibido = prazo transportadora + 2 dias uteis de producao.
  (function(){
    var F = [[1000,19999,3],[20000,28999,5],[29000,29999,5],[30000,39999,5],[40000,48999,10],[49000,49999,10],[50000,56999,10],[57000,57999,10],[58000,58999,10],[59000,59999,10],[60000,63999,10],[64000,64999,10],[65000,65999,10],[66000,68899,10],[68900,68999,15],[69000,69299,15],[69300,69399,15],[69400,69899,15],[69900,69999,18],[70000,72799,8],[72800,72999,10],[73000,73699,8],[73700,76799,10],[76800,76999,18],[77000,77999,18],[78000,78899,13],[78900,78999,18],[79000,79999,13],[80000,87999,5],[88000,89999,5],[90000,99999,5]];
    var PRODUCAO_DIAS_UTEIS = 2;
    var wrap = document.getElementById('pdp-cep-wrap');
    var input = document.getElementById('pdp-cep-input');
    var eta = document.getElementById('pdp-eta');
    var etaText = document.getElementById('pdp-eta-text');
    var change = document.getElementById('pdp-cep-change');
    if (!wrap || !input || !eta || !etaText || !change) return;
    /* bugfix 28/08 (achados #23/#24): CEP inválido falhava em silêncio total — agora tem nó de
       erro (#pdp-cep-error), com as MESMAS mensagens do /cart. */
    var errEl = document.getElementById('pdp-cep-error');
    function cepErro(msg){ if (errEl){ errEl.textContent = msg; errEl.hidden = false; } }
    function cepErroLimpa(){ if (errEl && !errEl.hidden) errEl.hidden = true; }
    /* Enter no CEP NÃO pode submeter o form da PDP (o campo mora dentro do <form
       action="/cart/add">): antes, Enter com CEP incompleto ADICIONAVA o quadro ao
       carrinho e abria o drawer — e ainda inflava add_to_cart no GA4/Ads. */
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter') {
        e.preventDefault();
        /* bugfix 28/08 (achado #23): CEP curto avisou nada — mesmo texto do /cart */
        if (input.value.replace(/\D/g, '').length < 8) cepErro('Digite um CEP válido (8 dígitos).');
      }
    });
    /* bugfix 28/08 (achado #24): quem digita parcial e sai do campo também fica sem resposta */
    input.addEventListener('blur', function(){
      var d = input.value.replace(/\D/g, '');
      if (d.length > 0 && d.length < 8) cepErro('Digite um CEP válido (8 dígitos).');
    });
    // Will 17/Jul: depois do CEP, o "Frete grátis" separado some — a palavra "grátis"
    // entra na própria linha da data ("Chega grátis até…"), economizando uma linha.
    var freeTxt = document.querySelector('.pdp__delivery-free-txt');
    var deliverySep = document.querySelector('.pdp__delivery-sep');
    /* medição (30/07): calcular CEP era invisível no GA4 — 1 evento por página, com o prazo em dias úteis */
    var cepMedido = false;

    var DIAS = ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'];
    var MESES = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];

    function lookup(cep5){
      for (var i = 0; i < F.length; i++) {
        if (cep5 >= F[i][0] && cep5 <= F[i][1]) return F[i][2];
      }
      return null;
    }
    function brNow(){ var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset() * 60000 - 3 * 3600000); }
    function addBusinessDays(from, days){
      var d = new Date(from);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6 && !ehFeriadoBR(d)) days--; // bugfix 28/08 (achado #16): feriado não é dia útil
      }
      return d;
    }
    function render(digits, userInitiated){
      if (digits.length !== 8) return false;
      /* bugfix 28/08 (sonda, achado #24): 8 dígitos IGUAIS (99999-999, 11111-111…) caem na faixa
         de alguma UF mas não existem — não fabrica data nem persiste no localStorage */
      if (/^(\d)\1{7}$/.test(digits)) {
        if (userInitiated) cepErro('CEP não encontrado. Frete grátis · 3 a 18 dias úteis conforme a região.');
        return false;
      }
      var prazo = lookup(parseInt(digits.slice(0, 5), 10));
      if (prazo === null) {
        /* bugfix 28/08 (achado #24): prefixo fora da tabela não fabrica data — mesma msg do /cart */
        if (userInitiated) cepErro('CEP não encontrado. Frete grátis · 3 a 18 dias úteis conforme a região.');
        return false;
      }
      cepErroLimpa();
      var now = brNow();
      /* bugfix 28/08 (achado #16): feriado em dia de semana não entra na produção hoje */
      var beforeCut = (now.getDay() >= 1 && now.getDay() <= 5 && !ehFeriadoBR(now) && now.getHours() < 17);
      var prodStart = beforeCut ? now : addBusinessDays(now, 1);
      var d = addBusinessDays(prodStart, PRODUCAO_DIAS_UTEIS + prazo);
      etaText.textContent = 'Chega grátis até ' + DIAS[d.getDay()] + ', ' + d.getDate() + ' de ' + MESES[d.getMonth()];
      /* bugfix 28/08 (achado #17): só mede cálculo DE VERDADE — a restauração do localStorage
         no boot emitia 1 evento por PDP e inflava a métrica pdp_calcula_cep */
      if (userInitiated && !cepMedido) { cepMedido = true;
        try { if (typeof gtag === 'function') gtag('event', 'pdp_calcula_cep', { prazo_dias: PRODUCAO_DIAS_UTEIS + prazo }); } catch(e) {}
      }
      wrap.hidden = true;
      eta.hidden = false;
      if (freeTxt) freeTxt.hidden = true;
      if (deliverySep) deliverySep.hidden = true;
      try { localStorage.setItem('pdq_cep', digits); } catch(e) {}
      return true;
    }
    input.addEventListener('input', function(){
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      cepErroLimpa(); /* bugfix 28/08 (achado #23): redigitou = erro some */
      if (v.length === 8) render(v, true);
    });
    change.addEventListener('click', function(){
      eta.hidden = true;
      wrap.hidden = false;
      if (freeTxt) freeTxt.hidden = false;
      if (deliverySep) deliverySep.hidden = false;
      input.focus();
    });
    try {
      var saved = localStorage.getItem('pdq_cep');
      if (saved && saved.length === 8) render(saved);
    } catch(e) {}
  })();

  // ===== FEATURE 2: Urgência produção (corte 16h SP; hoje/amanhã/segunda-feira) =====
  var urgencyEl = document.getElementById('pdp-urgency');
  if (urgencyEl) {
    var urgencyTimer = null;
    var urgencyVisible = true;
    function updateUrgency() {
      // Horário de São Paulo (BRT, UTC-3, sem horário de verão desde 2019)
      var now = new Date();
      var brt = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) - (3 * 3600000));
      var hour = brt.getHours();
      var min = brt.getMinutes();
      var day = brt.getDay(); // 0=domingo, 1=segunda ... 5=sexta, 6=sábado
      var agora = hour * 60 + min;
      var CORTE = 17 * 60;                      // corte de produção 17:00 SP (alinhado ao carrinho)
      var FIM_DIA = 24 * 60;                    // meia-noite
      // bugfix 28/08 (achado #16): feriado nacional em dia de semana NÃO é dia útil — a página
      // dizia "entra na produção hoje" num 07/09 (segunda) e prometia prazo que a fábrica não cumpre
      var diaUtil = (day >= 1 && day <= 5 && !ehFeriadoBR(brt));

      var falta, quando;
      if (diaUtil && agora < CORTE) {
        // Dia útil, antes do corte => conta até as 17h, entra HOJE
        falta = CORTE - agora;
        quando = 'hoje';
      } else {
        // Após o corte, fim de semana ou feriado => conta até o FIM DO DIA
        falta = FIM_DIA - agora;
        // bugfix 28/08 (achado #16): "quando" agora é o PRÓXIMO dia útil de verdade (pula
        // fim de semana E feriado). Semana sem feriado se comporta igual a antes:
        // seg-qui após o corte => "amanhã"; sex/sáb/dom => "segunda-feira".
        var DIAS_SEMANA = ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'];
        var prox = new Date(brt), passos = 0;
        do { prox.setDate(prox.getDate() + 1); passos++; } while (prox.getDay() === 0 || prox.getDay() === 6 || ehFeriadoBR(prox));
        quando = (passos === 1 && day >= 1 && day <= 4) ? 'amanhã' : DIAS_SEMANA[prox.getDay()];
      }

      var h = Math.floor(falta / 60);
      var m = falta % 60;
      var tempo, prefixo;
      if (h >= 1) {
        tempo = m > 0 ? (h + 'h ' + m + 'min') : (h + 'h');
        prefixo = (h === 1) ? 'dentro da próxima' : 'dentro das próximas';
      } else {
        tempo = m + 'min';
        prefixo = (m === 1) ? 'dentro do próximo' : 'dentro dos próximos';
      }
      // Will 18/Jul: DEPOIS do CEP (data de chegada já mostrada na linha de cima), a
      // urgência fala só do tempo restante — sem "entra na produção X" (a mensagem é
      // "chega até o dia tal comprando dentro das próximas tais horas"). ANTES do CEP
      // (ainda calculando o frete) fica como estava.
      var etaEl = document.getElementById('pdp-eta');
      var cepFeito = etaEl && !etaEl.hidden;
      if (cepFeito) {
        urgencyEl.innerHTML = '⚡ Comprando ' + prefixo + ' <strong>' + tempo + '</strong>';
      } else {
        urgencyEl.innerHTML = '⚡ Comprando ' + prefixo + ' <strong>' + tempo + '</strong>, seu pedido entra na produção <strong>' + quando + '</strong>';
      }
    }
    function startUrgency() {
      if (urgencyTimer || document.hidden || !urgencyVisible) return;
      urgencyTimer = setInterval(updateUrgency, 60000);
    }
    function stopUrgency() {
      if (urgencyTimer) { clearInterval(urgencyTimer); urgencyTimer = null; }
    }
    // FASE 4: defer primeira execucao via requestIdleCallback (libera main thread durante LCP)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(updateUrgency, { timeout: 2000 });
    } else {
      setTimeout(updateUrgency, 100);
    }
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) { stopUrgency(); } else { updateUrgency(); startUrgency(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        urgencyVisible = entries[0].isIntersecting;
        if (urgencyVisible) { updateUrgency(); startUrgency(); } else { stopUrgency(); }
      }).observe(urgencyEl);
    } else {
      startUrgency();
    }
    // Will 18/Jul: ao preencher/limpar o CEP (#pdp-eta mostra/esconde) a urgência troca de
    // texto (com/sem "entra na produção") — reage NA HORA, sem esperar o tick de 60s.
    (function(){
      var etaEl = document.getElementById('pdp-eta');
      if (etaEl && 'MutationObserver' in window) {
        new MutationObserver(function(){ updateUrgency(); }).observe(etaEl, { attributes: true, attributeFilter: ['hidden'] });
      }
    })();
  }

  // ===== FEATURE 3: Share via WhatsApp =====
  var shareWa = document.getElementById('pdp-share-wa');
  if (shareWa) {
    shareWa.addEventListener('click', function(e) {
      e.preventDefault();
      var title = document.querySelector('.pdp__title-mobile, .pdp__title');
      var titleText = title ? title.textContent.trim() : '';
      var priceElShare = document.getElementById('pdp-price');
      var priceText = priceElShare ? priceElShare.textContent.trim() : '';
      var installElShare = document.getElementById('pdp-installment-value');
      var installText = installElShare ? '12x de ' + installElShare.textContent.trim() + ' sem juros' : '';
      /* UTM no link compartilhado (30/07) \u2014 mesmo motivo do botao da galeria; URL canonica, sem ?variant */
      var url = window.location.origin + window.location.pathname + '?utm_source=whatsapp&utm_medium=share';
      var msg = 'O que voc\u00EA acha desse quadro?\n\n\uD83D\uDDBC ' + titleText + '\n\uD83D\uDCB0 ' + priceText + ' (' + installText + ')\n\uD83D\uDE9A Frete Gr\u00E1tis\n\n' + url;
      window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
    });
  }

  /* atalho do simulador (31/07): rolagem suave s\u00F3 aqui \u2014 smooth global quebraria o
     "voltar pro lugar" da cole\u00E7\u00E3o */
  var simAtalho = document.querySelector('[data-sim-atalho]');
  if (simAtalho) {
    simAtalho.addEventListener('click', function(e){
      var alvoSim = document.getElementById('simulador');
      if (alvoSim){ e.preventDefault(); alvoSim.scrollIntoView({ behavior:'smooth', block:'start' }); }
    });
  }

})();

/* bloco morto apagado em 21/07: o markup-alvo nao existe em nenhum template (verificado por grep no tema + HTML renderizado) */

/* ===== Carrossel de cards da descrição (mobile) ===== */
(function() {
  var grid = document.querySelector('.pdq-g');
  if (!grid) return;
  var cards = grid.querySelectorAll('.pdq-c');
  if (cards.length < 2) return;

  // Criar dots
  var dotsWrap = document.createElement('div');
  dotsWrap.className = 'pdq-dots';
  cards.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.className = 'pdq-dot' + (i === 0 ? ' pdq-dot--active' : '');
    dot.setAttribute('aria-label', 'Card ' + (i + 1));
    dot.addEventListener('click', function() {
      cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
    dotsWrap.appendChild(dot);
  });
  grid.parentNode.insertBefore(dotsWrap, grid.nextSibling);

  // Observer para atualizar dots ao scrollar
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = Array.from(cards).indexOf(entry.target);
        dotsWrap.querySelectorAll('.pdq-dot').forEach(function(d, i) {
          d.classList.toggle('pdq-dot--active', i === idx);
        });
      }
    });
  }, { root: grid, threshold: 0.6 });
  cards.forEach(function(c) { observer.observe(c); });

  // Drag com mouse (desktop) — listeners no document só durante drag
  var isDrag = false, sX = 0, sScroll = 0, dMoved = false;
  function onCardsDragMove(e) {
    if (!isDrag) return;
    var dx = e.pageX - sX;
    if (Math.abs(dx) > 5) dMoved = true;
    grid.scrollLeft = sScroll - dx;
  }
  function onCardsDragEnd() {
    if (!isDrag) return;
    isDrag = false;
    grid.style.cursor = 'grab';
    grid.style.scrollSnapType = 'x mandatory';
    document.removeEventListener('mousemove', onCardsDragMove);
  }
  grid.addEventListener('mousedown', function(e) {
    isDrag = true; dMoved = false;
    sX = e.pageX; sScroll = grid.scrollLeft;
    grid.style.cursor = 'grabbing';
    grid.style.scrollSnapType = 'none';
    document.addEventListener('mousemove', onCardsDragMove);
    document.addEventListener('mouseup', onCardsDragEnd, { once: true });
    e.preventDefault();
  });
})();

/* bloco morto apagado em 21/07: o markup-alvo nao existe em nenhum template (verificado por grep no tema + HTML renderizado) */

/* bloco morto apagado em 21/07: o markup-alvo nao existe em nenhum template (verificado por grep no tema + HTML renderizado) */

/* bloco morto apagado em 21/07: o markup-alvo nao existe em nenhum template (verificado por grep no tema + HTML renderizado) */


  /* ═══ MOVIDOS DO INLINE (27/07): rodavam em <script> no corpo e inflavam o HTML da PDP
     (~12KB brotli por pageview). Aqui compilam pro scripts.js — cacheado, deferred. São
     IIFEs de interação com guards próprios; defer não muda comportamento. ═══ */

(function(){
    'use strict';
    /* carrossel — setas + arrastar */
    var track=document.querySelector('.pdp-ugc__grid');
    if(track){
      var prev=document.querySelector('[data-ugc-prev]'), next=document.querySelector('[data-ugc-next]');
      function step(){ var c=track.querySelector('.pdp-ugc__card'); return (c?c.getBoundingClientRect().width:230)+18; }
      function sync(){ if(!prev||!next)return; prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2; }
      if(prev)prev.addEventListener('click',function(){ track.scrollBy({left:-step()*2,behavior:'smooth'}); });
      if(next)next.addEventListener('click',function(){ track.scrollBy({left:step()*2,behavior:'smooth'}); });
      track.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync);
      /* estado inicial das setas so quando a secao aproxima da tela — sync le scrollWidth,
         e no parse isso forcava reflow da pagina inteira (7ms no trace 27/07) */
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en,obs){ if(en[0].isIntersecting){ obs.disconnect(); sync(); } },{rootMargin:'300px'}).observe(track);
      } else { sync(); }
      var down=false,sx=0,sl=0,moved=false;
      /* BUG CORRIGIDO (Will, 13/Jul): este arraste manual rodava TAMBÉM no toque e não
         bloqueava a seleção de texto. Ao rolar a página com o dedo/mouse por cima do
         carrossel, o site começava a "selecionar tudo".
         Agora: (1) no toque, deixamos o navegador rolar nativo — não interceptamos nada;
                (2) no mouse, preventDefault impede a seleção começar. */
      track.addEventListener('pointerdown',function(e){
        if(e.pointerType && e.pointerType !== 'mouse') return;   // toque: rolagem nativa
        if(e.button!==undefined && e.button!==0) return;
        down=true;moved=false;sx=e.clientX;sl=track.scrollLeft;
        track.classList.add('is-dragging');
        e.preventDefault();                                       // não inicia seleção
      });
      track.addEventListener('pointermove',function(e){ if(!down)return; var dx=e.clientX-sx; if(Math.abs(dx)>4)moved=true; track.scrollLeft=sl-dx; e.preventDefault(); });
      function endDrag(){ if(!down)return; down=false;track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup',endDrag); track.addEventListener('pointercancel',endDrag); track.addEventListener('pointerleave',endDrag);
      track.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } },true);
    }
    /* O alto-falante do card NÃO liga mais o som inline (Will 22/Jul): ele fica ali só como
       ícone, e clicar nele — como em qualquer ponto do card — abre o player tela cheia (onde o
       som toca). O handler de clique fica todo no bloco do player Reels, sem exceção pro botão. */

    /* ===== AUTOPLAY ao entrar na tela (Will 22/Jul) =====
       Poster estático (o <img>) → quando o card fica ~50% visível, o vídeo BAIXA (só aqui,
       preload=none) e toca MUDO em loop; ao sair, pausa e re-muda. Som só pelo botão acima.
       Como a seção fica bem abaixo da dobra e só os 2-3 cards visíveis carregam, o load frio
       não baixa vídeo nenhum → PageSpeed intacto. `is-playing` revela o vídeo sobre o poster. */
    document.querySelectorAll('.pdp-ugc__card').forEach(function(card){
      var vid = card.querySelector('video');
      if(vid) vid.addEventListener('playing', function(){ card.classList.add('is-playing'); });
    });
    if('IntersectionObserver' in window){
      var autoObs = new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          var card = en.target, vid = card.querySelector('video');
          if(!vid) return;
          if(en.isIntersecting){
            if(!vid.src){ vid.src = vid.getAttribute('data-src'); vid.load(); }  /* só AQUI baixa */
            var p = vid.play(); if(p && p.catch) p.catch(function(){});
          } else {
            vid.pause();
            vid.muted = true; card.classList.remove('is-unmuted');  /* rolou pra fora: sem som surpresa */
          }
        });
      }, { threshold: 0.5 });
      document.querySelectorAll('.pdp-ugc__card').forEach(function(c){ autoObs.observe(c); });
    }
  })();

  /* ===== Player TELA CHEIA estilo Reels (mobile) — Will 22/Jul =====
     Toca no card → abre em tela cheia no vídeo tocado; arrasta pro lado troca de vídeo; X fecha;
     som ligado. Overlay construído sob demanda (nada carrega antes de abrir) e cada vídeo só baixa
     quando fica ativo (atual ± 1) → zero peso extra no carregamento da página. */
  (function(){
    var cards = [].slice.call(document.querySelectorAll('.pdp-ugc__card'));
    if(!cards.length) return;
    var ehMobile = function(){ return window.matchMedia('(max-width:900px)').matches; };
    var dados = cards.map(function(c){
      var v=c.querySelector('video'), img=c.querySelector('.pdp-ugc__poster');
      return { src:v&&v.getAttribute('data-src'), poster:img&&img.getAttribute('src'), alt:(img&&img.getAttribute('alt'))||'',
        prodUrl:c.getAttribute('data-prod-url')||'', prodImg:c.getAttribute('data-prod-img')||'', prodTitle:c.getAttribute('data-prod-title')||'',
        prodId:c.getAttribute('data-prod-id')||'', prodHandle:c.getAttribute('data-prod-handle')||'', prodPrice:c.getAttribute('data-prod-price')||'' };
    });
    var SND_ON='<svg class="ic-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
    var SND_OFF='<svg class="ic-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="22" y1="9" x2="16" y2="15"/><line x1="16" y1="9" x2="22" y2="15"/></svg>';
    var HEART='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    var ov=null, track=null, slides=[], vids=[], dots=[], atual=-1, muted=false, io=null, travaHint=false, navUp=null, navDown=null, shopMain=null, shopImg=null, shopName=null, shopPrice=null, shopBuy=null, railFav=null, railShare=null, toastTimer=null;
    /* medição (30/07): o player de reels era invisível no GA4 — abrir, assistir, som e clique no produto */
    function trkUgc(n,p){ try{ if(typeof gtag==='function') gtag('event', n, p||{}); }catch(_){} }

    function toast(msg){
      if(!ov) return;
      var t=ov.querySelector('.pdp-ugc-reels__toast');
      if(!t){ t=document.createElement('div'); t.className='pdp-ugc-reels__toast'; ov.appendChild(t); }
      t.textContent=msg; t.classList.add('is-on');
      clearTimeout(toastTimer); toastTimer=setTimeout(function(){ t.classList.remove('is-on'); }, 1800);
    }
    function build(){
      if(ov) return;
      ov=document.createElement('div'); ov.className='pdp-ugc-reels';
      ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-label','Vídeos de clientes na parede de casa');
      track=document.createElement('div'); track.className='pdp-ugc-reels__track';
      dados.forEach(function(d,i){
        var s=document.createElement('div'); s.className='pdp-ugc-reels__slide'; s.setAttribute('data-i',i);
        var fr=document.createElement('div'); fr.className='pdp-ugc-reels__frame';
        var p=document.createElement('img'); p.className='pdp-ugc-reels__poster'; p.src=d.poster; p.alt=d.alt; p.decoding='async';
        var v=document.createElement('video'); v.className='pdp-ugc-reels__v'; v.loop=true; v.setAttribute('playsinline',''); v.playsInline=true; v.preload='none'; v.setAttribute('data-src',d.src);
        fr.appendChild(p); fr.appendChild(v); s.appendChild(fr); track.appendChild(s); slides.push(s); vids.push(v);
      });
      ov.appendChild(track);
      var x=document.createElement('button'); x.type='button'; x.className='pdp-ugc-reels__close'; x.setAttribute('aria-label','Fechar');
      x.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      x.addEventListener('click', fechar); ov.appendChild(x);
      var dc=document.createElement('div'); dc.className='pdp-ugc-reels__count';
      dados.forEach(function(){ var d=document.createElement('span'); d.className='pdp-ugc-reels__dot'; dc.appendChild(d); dots.push(d); });
      ov.appendChild(dc);
      /* rail favoritar + compartilhar (Will 27/07 — estilo TikTok, mobile e desktop) */
      var rail=document.createElement('div'); rail.className='pdp-ugc-reels__rail';
      railFav=document.createElement('button'); railFav.type='button'; railFav.className='pdp-ugc-reels__act pdp-ugc-reels__fav'; railFav.setAttribute('aria-label','Favoritar este quadro');
      railFav.innerHTML='<span class="pdp-ugc-reels__act-ic"><svg class="ic-line" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><svg class="ic-fill" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></span><span>Favoritos</span>';
      railFav.addEventListener('click', function(){
        var d=dados[atual]; if(!d||!d.prodId||!window.PoraoWishlist) return;
        var added=window.PoraoWishlist.toggle({ id:d.prodId, handle:d.prodHandle, title:d.prodTitle, image:d.prodImg, price:d.prodPrice, url:d.prodUrl });
        railFav.classList.toggle('is-fav', added);
        window.PoraoWishlist.sync();
        toast(added ? 'Salvo nos favoritos' : 'Removido dos favoritos');
      });
      railShare=document.createElement('button'); railShare.type='button'; railShare.className='pdp-ugc-reels__act'; railShare.setAttribute('aria-label','Compartilhar');
      railShare.innerHTML='<span class="pdp-ugc-reels__act-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg></span><span>Compartilhar</span>';
      railShare.addEventListener('click', function(){
        var d=dados[atual]||{};
        var url = d.prodUrl ? (location.origin + d.prodUrl) : (location.origin + location.pathname);
        var titulo = d.prodTitle || 'Por\u00e3o dos Quadros';
        if(navigator.share){
          navigator.share({ title: titulo, text: 'Olha esse quadro na parede de um cliente do Por\u00e3o dos Quadros', url: url }).catch(function(){});
        } else if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(url).then(function(){ toast('Link copiado!'); }, function(){ toast('Copie o link: '+url); });
        } else { toast('Copie o link: '+url); }
      });
      rail.appendChild(railFav); rail.appendChild(railShare); ov.appendChild(rail);
      var snd=document.createElement('button'); snd.type='button'; snd.className='pdp-ugc-reels__snd'; snd.setAttribute('aria-label','Ativar ou desativar som'); snd.innerHTML=SND_ON+SND_OFF;
      snd.addEventListener('click', function(){ muted=!muted; ov.classList.toggle('is-muted',muted); if(vids[atual]) vids[atual].muted=muted; if(!muted) trkUgc('ugc_reels_som'); });
      ov.appendChild(snd);
      var nav=document.createElement('div'); nav.className='pdp-ugc-reels__nav';
      navUp=document.createElement('button'); navUp.type='button'; navUp.className='pdp-ugc-reels__navbtn'; navUp.setAttribute('aria-label','Vídeo anterior');
      navUp.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>';
      navDown=document.createElement('button'); navDown.type='button'; navDown.className='pdp-ugc-reels__navbtn'; navDown.setAttribute('aria-label','Próximo vídeo');
      navDown.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      navUp.addEventListener('click', function(){ navegar(-1); });
      navDown.addEventListener('click', function(){ navegar(1); });
      nav.appendChild(navUp); nav.appendChild(navDown); ov.appendChild(nav);
      var cap=document.createElement('div'); cap.className='pdp-ugc-reels__cap';
      cap.innerHTML='<b>'+HEART+'Cliente do Porão dos Quadros</b><span>Quadro de verdade, na parede de casa</span>';
      ov.appendChild(cap);
      /* card de produto (foto + nome + Comprar) — preenchido por vídeo no ativar() */
      var shop=document.createElement('div'); shop.className='pdp-ugc-reels__shop';
      shopMain=document.createElement('a'); shopMain.className='pdp-ugc-reels__shop-main'; shopMain.href='#';
      shopImg=document.createElement('img'); shopImg.className='pdp-ugc-reels__shop-img'; shopImg.alt=''; shopImg.decoding='async';
      shopName=document.createElement('span'); shopName.className='pdp-ugc-reels__shop-name';
      /* preço no card (31/07): o dado já vinha no data-prod-price (centavos) e não era mostrado —
         111 vídeos assistidos e 0 cliques no Comprar; preço dá o cheiro de informação que faltava */
      shopPrice=document.createElement('span'); shopPrice.className='pdp-ugc-reels__shop-price';
      var shopTxt=document.createElement('span'); shopTxt.className='pdp-ugc-reels__shop-txt';
      shopTxt.appendChild(shopName); shopTxt.appendChild(shopPrice);
      shopMain.appendChild(shopImg); shopMain.appendChild(shopTxt);
      /* "Ver o quadro", não "Comprar" (Will 31/07): o botão leva à PDP — "Comprar" soava compra imediata */
      shopBuy=document.createElement('a'); shopBuy.className='pdp-ugc-reels__shop-buy'; shopBuy.href='#'; shopBuy.textContent='Ver o quadro';
      shop.appendChild(shopMain); shop.appendChild(shopBuy);
      shop.addEventListener('click', function(e){ if(e.target.closest('a')) trkUgc('ugc_reels_produto'); });
      ov.appendChild(shop);
      var sw=document.createElement('div'); sw.className='pdp-ugc-reels__swipe';
      sw.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg><span>deslize para ver mais</span>';
      ov.appendChild(sw);
      document.body.appendChild(ov);
      io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){ if(en.isIntersecting && en.intersectionRatio>=0.6){ ativar(+en.target.getAttribute('data-i')); } });
      }, { root: track, threshold:[0.6] });
      slides.forEach(function(s){ io.observe(s); });
      /* esconde o "deslize" só quando o usuário rola de verdade (travaHint ignora o scroll
         programático da abertura e o assentar do snap) */
      track.addEventListener('scroll', function(){ if(!travaHint) ov.classList.add('scrolled'); }, { passive:true });
      /* GESTO HORIZONTAL (Will 22/Jul): quem prefere arrastar PRO LADO também troca de vídeo.
         O vertical é o scroll-snap nativo (pan-y); o horizontal fica livre pro JS. Esquerda =
         próximo, direita = anterior. Só conta se for claramente horizontal, pra não brigar
         com o deslize vertical. */
      var tsx=0, tsy=0, tmoved=false;
      ov.addEventListener('touchstart', function(e){ if(e.touches.length!==1) return; tsx=e.touches[0].clientX; tsy=e.touches[0].clientY; tmoved=false; }, { passive:true });
      ov.addEventListener('touchmove', function(){ tmoved=true; }, { passive:true });
      ov.addEventListener('touchend', function(e){
        if(!tmoved) return;
        var t=e.changedTouches[0]; if(!t) return;
        var dx=t.clientX-tsx, dy=t.clientY-tsy;
        if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.4){ navegar(dx<0 ? 1 : -1); }
      }, { passive:true });
      /* DESKTOP: roda do mouse troca de vídeo (uma por gesto, com trava anti-pulo); clicar no
         fundo escuro (fora da coluna) fecha. */
      var wheelLock=false;
      ov.addEventListener('wheel', function(e){
        if(!window.matchMedia('(min-width:901px)').matches) return;
        e.preventDefault();
        if(wheelLock || Math.abs(e.deltaY) < 6) return;
        wheelLock=true; navegar(e.deltaY>0 ? 1 : -1);
        setTimeout(function(){ wheelLock=false; }, 620);
      }, { passive:false });
      ov.addEventListener('click', function(e){
        if(!window.matchMedia('(min-width:901px)').matches) return;
        if(e.target.classList.contains('pdp-ugc-reels__slide') || e.target.classList.contains('pdp-ugc-reels__track')){ fechar(); }
      });
    }
    function carrega(k){ if(k<0||k>=vids.length) return; var v=vids[k]; if(!v.src && v.getAttribute('data-src')){ v.src=v.getAttribute('data-src'); v.load(); } }
    function ativar(i){
      if(i===atual) return;
      if(atual>=0 && vids[atual]){ try{ vids[atual].pause(); }catch(e){} slides[atual].classList.remove('is-live'); }
      atual=i;
      dots.forEach(function(d,k){ d.classList.toggle('is-on', k===i); });
      if(navUp) navUp.disabled = (i<=0);
      if(navDown) navDown.disabled = (i>=vids.length-1);
      /* card de produto do vídeo ativo (some se o vídeo não tiver produto vinculado) */
      var d=dados[i];
      if(railFav){
        if(d && d.prodId){
          railFav.style.display='';
          railFav.classList.toggle('is-fav', !!(window.PoraoWishlist && window.PoraoWishlist.has(d.prodId)));
        } else { railFav.style.display='none'; }
      }
      if(d && d.prodUrl){
        if(d.prodImg) shopImg.src=d.prodImg; shopImg.style.display = d.prodImg ? '' : 'none';
        shopName.textContent = d.prodTitle || 'Ver o quadro';
        var pc = parseInt(d.prodPrice, 10);
        if (shopPrice){
          if (pc > 0){ shopPrice.textContent = 'R$ ' + (pc/100).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); shopPrice.hidden = false; }
          else { shopPrice.hidden = true; }
        }
        shopMain.href=d.prodUrl; shopBuy.href=d.prodUrl;
        ov.classList.add('has-shop');
      } else {
        ov.classList.remove('has-shop');
      }
      carrega(i-1); carrega(i); carrega(i+1);
      trkUgc('ugc_reels_video', { indice: i });
      var v=vids[i]; v.muted=muted; slides[i].classList.add('is-live');
      var p=v.play(); if(p&&p.catch) p.catch(function(){ v.muted=true; muted=true; ov.classList.add('is-muted'); var q=v.play(); if(q&&q.catch)q.catch(function(){}); });
    }
    /* navega N posições (usado pelo gesto HORIZONTAL); rola suave -> o IO ativa o novo slide */
    function navegar(dir){
      var alvo=Math.max(0, Math.min(vids.length-1, atual+dir));
      if(alvo===atual) return;
      ov.classList.add('scrolled');
      track.scrollTo({ top: alvo * (track.clientHeight||window.innerHeight), behavior:'smooth' });
    }
    function abrir(i){
      build();
      trkUgc('ugc_reels_abre', { indice: i });
      document.documentElement.classList.add('pdp-reels-lock'); document.body.classList.add('pdp-reels-lock');
      ov.classList.add('is-open');
      ov.classList.remove('scrolled');
      atual=-1;
      travaHint=true;
      track.scrollTop = i * (track.clientHeight || window.innerHeight);   /* posiciona no vídeo tocado */
      setTimeout(function(){ travaHint=false; }, 450);
      ativar(i);
      document.addEventListener('keydown', onKey);
    }
    function fechar(){
      if(!ov) return;
      ov.classList.remove('is-open');
      vids.forEach(function(v){ try{ v.pause(); }catch(e){} });
      if(atual>=0 && slides[atual]) slides[atual].classList.remove('is-live');
      atual=-1;
      document.documentElement.classList.remove('pdp-reels-lock'); document.body.classList.remove('pdp-reels-lock');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){
      if(e.key==='Escape'){ fechar(); return; }
      if(e.key==='ArrowDown'||e.key==='ArrowRight'){ e.preventDefault(); navegar(1); }
      else if(e.key==='ArrowUp'||e.key==='ArrowLeft'){ e.preventDefault(); navegar(-1); }
    }
    cards.forEach(function(c,i){
      c.addEventListener('click', function(e){
        /* clicar em QUALQUER ponto do card — inclusive no alto-falante — abre o player tela
           cheia (Will 22/Jul), no mobile E no desktop */
        e.preventDefault(); abrir(i);
      });
    });
  })();

(function(){
    'use strict';
    /* ===== POLÍTICA DE VÍDEO DA PDP (Will, 13/Jul; exceção 23/Jul) =====
       PADRÃO: vídeo NÃO abre sozinho — foto de capa parada + botão de play; só toca (e só BAIXA)
       quando a pessoa toca. EXCEÇÃO (Will 23/Jul): os 3 vídeos do "melhor acabamento"
       (.pdp-craft__video) tocam SOZINHOS ao chegar perto da tela (autoplay lazy — o MP4 só baixa
       nesse momento; pula reduce-motion/economia de dados/2G). Ver o branch pdp-craft__video abaixo.

       ANTES: cada seção tinha seu próprio IntersectionObserver dando play ao entrar na tela
       (alguns com 300px de antecedência, outros com autoplay nativo — que tocava já no
       carregamento). Resultado: vídeo "abrindo" sozinho e 22 MB baixados por visita.

       Este script é o ÚNICO dono dos vídeos da PDP: pega TODO <video data-src> da página,
       venha da seção que vier. Os observers das outras seções foram removidos.
       Roda no DOMContentLoaded porque as demais seções da PDP só existem depois deste script. */
    function iniciarVideos(){
      /* A UGA ("Na parede de quem comprou") tem AUTOPLAY próprio ao rolar (script da seção) —
         fica de fora deste controlador de clique-para-tocar pra não ganhar o botão de play. */
      var vids = document.querySelectorAll('video[data-src]:not(.pdp-ugc__video)');
      if(!vids.length) return;

      /* ===== POSTER TAMBÉM É LAZY (21/07) =====
         O atributo poster= baixa NA HORA do layout — furava o preload="none" e o lazy:
         ~570 KB de pôsteres de seções lá embaixo baixavam no load frio, competindo com o
         LCP. Agora os vídeos usam data-poster e o pôster só é aplicado quando a seção
         se APROXIMA da tela (600px antes — ninguém vê chegar sem pôster). */
      var poObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var v = en.target;
          if(v.dataset.poster && !v.poster){ v.poster = v.dataset.poster; }
          poObs.unobserve(v);
        });
      }, { rootMargin: '600px 0px' }) : null;

      var ICONE_PLAY = '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72c0 .83.92 1.34 1.63.9l10.5-6.86c.66-.43.66-1.4 0-1.83L9.63 4.24C8.92 3.8 8 4.31 8 5.14z"/></svg>';

      /* ===== PLAYER "showcase" (Will 23/Jul): abre os vídeos da seção em TELA CHEIA e deixa
         DESLIZAR PRO LADO entre eles (mesmo espírito do Reels dos clientes), SEM controles nativos
         e SEM card de comprar. Construído sob demanda; cada vídeo só baixa quando fica ativo (±1). */
      var show=null, sTrack=null, sSlides=[], sVids=[], sDots=[], sAtual=-1, sIo=null, sNavL=null, sNavR=null, sHintLock=false, sData=[], sCap=null;
      var SHOW_X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      var SHOW_L='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
      var SHOW_R='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
      function carregaShow(k){ if(k<0||k>=sVids.length) return; var v=sVids[k]; if(!v.src && v.getAttribute('data-src')){ v.src=v.getAttribute('data-src'); v.load(); } }
      function ativarShow(i){
        if(i===sAtual || i<0 || i>=sVids.length) return;
        if(sAtual>=0 && sVids[sAtual]){ try{ sVids[sAtual].pause(); }catch(e){} if(sSlides[sAtual]) sSlides[sAtual].classList.remove('is-live'); }
        sAtual=i;
        sDots.forEach(function(d,k){ d.classList.toggle('is-on', k===i); });
        if(sNavL) sNavL.disabled=(i<=0); if(sNavR) sNavR.disabled=(i>=sVids.length-1);
        carregaShow(i); carregaShow(i-1); carregaShow(i+1);
        if(sCap){ var cd=sData[i]||{}; sCap.innerHTML='';
          if(cd.sub){ var ce=document.createElement('span'); ce.className='pdp-vshow__cap-eyebrow'; ce.textContent=cd.sub; sCap.appendChild(ce); }
          if(cd.title){ var cb=document.createElement('b'); cb.textContent=cd.title; sCap.appendChild(cb); } }
        var v=sVids[i]; if(v){ v.muted=true; v.addEventListener('playing', function(){ if(sSlides[i]) sSlides[i].classList.add('is-live'); }, {once:true}); var pp=v.play(); if(pp&&pp.catch) pp.catch(function(){}); }
      }
      /* scroll INSTANTÂNEO (não smooth): o smooth era cancelado pelo reflow do vídeo carregando
         (scroll-snap mandatory re-snapava pra 0). Instante + snap = confiável. */
      function navShow(dir){ var k=sAtual+dir; if(k<0||k>=sSlides.length||!sTrack) return; sHintLock=true; sTrack.scrollLeft=k*sTrack.clientWidth; ativarShow(k); setTimeout(function(){ sHintLock=false; },300); }
      function fecharShow(){
        if(!show) return;
        if(sAtual>=0 && sVids[sAtual]){ try{ sVids[sAtual].pause(); }catch(e){} }
        var velho=show; show=null; sSlides=[]; sVids=[]; sDots=[]; sAtual=-1;
        velho.classList.remove('is-open');
        document.documentElement.classList.remove('pdp-reels-lock'); document.body.classList.remove('pdp-reels-lock');
        setTimeout(function(){ if(velho.parentNode) velho.parentNode.removeChild(velho); }, 40);
      }
      function abrirShow(lista, start){
        if(!lista || !lista.length) return;
        sData=lista;
        show=document.createElement('div'); show.className='pdp-vshow'; show.setAttribute('role','dialog'); show.setAttribute('aria-modal','true'); show.setAttribute('aria-label','Vídeos de acabamento');
        sTrack=document.createElement('div'); sTrack.className='pdp-vshow__track'; sSlides=[]; sVids=[]; sDots=[];
        lista.forEach(function(d,i){
          var s=document.createElement('div'); s.className='pdp-vshow__slide'; s.setAttribute('data-i',i);
          var fr=document.createElement('div'); fr.className='pdp-vshow__frame';
          var p=document.createElement('img'); p.className='pdp-vshow__poster'; if(d.poster) p.src=d.poster; p.alt=''; p.decoding='async';
          var v=document.createElement('video'); v.className='pdp-vshow__v'; v.loop=true; v.muted=true; v.setAttribute('playsinline',''); v.playsInline=true; v.preload='none'; v.setAttribute('data-src',d.src);
          fr.appendChild(p); fr.appendChild(v); s.appendChild(fr); sTrack.appendChild(s); sSlides.push(s); sVids.push(v);
        });
        show.appendChild(sTrack);
        var x=document.createElement('button'); x.type='button'; x.className='pdp-vshow__close'; x.setAttribute('aria-label','Fechar'); x.innerHTML=SHOW_X; x.addEventListener('click', fecharShow); show.appendChild(x);
        var dc=document.createElement('div'); dc.className='pdp-vshow__count'; lista.forEach(function(){ var d=document.createElement('span'); d.className='pdp-vshow__dot'; dc.appendChild(d); sDots.push(d); }); show.appendChild(dc);
        var nav=document.createElement('div'); nav.className='pdp-vshow__nav';
        sNavL=document.createElement('button'); sNavL.type='button'; sNavL.className='pdp-vshow__navbtn'; sNavL.setAttribute('aria-label','Anterior'); sNavL.innerHTML=SHOW_L;
        sNavR=document.createElement('button'); sNavR.type='button'; sNavR.className='pdp-vshow__navbtn'; sNavR.setAttribute('aria-label','Próximo'); sNavR.innerHTML=SHOW_R;
        sNavL.addEventListener('click', function(){ navShow(-1); }); sNavR.addEventListener('click', function(){ navShow(1); });
        nav.appendChild(sNavL); nav.appendChild(sNavR); show.appendChild(nav);
        if(lista.length>1){ var sw=document.createElement('div'); sw.className='pdp-vshow__swipe'; sw.innerHTML=SHOW_R+'<span>deslize para ver mais</span>'; show.appendChild(sw); }
        sCap=document.createElement('div'); sCap.className='pdp-vshow__cap'; show.appendChild(sCap);
        document.body.appendChild(show);
        sIo=new IntersectionObserver(function(ents){ ents.forEach(function(en){ if(en.isIntersecting && en.intersectionRatio>=0.6){ ativarShow(+en.target.getAttribute('data-i')); } }); }, { root: sTrack, threshold:[0.6] });
        sSlides.forEach(function(s){ sIo.observe(s); });
        sTrack.addEventListener('scroll', function(){ if(!sHintLock) show.classList.add('scrolled'); }, { passive:true });
        var wl=false;
        show.addEventListener('wheel', function(e){ if(!window.matchMedia('(min-width:901px)').matches) return; e.preventDefault(); if(wl||Math.abs(e.deltaY)<6) return; wl=true; navShow(e.deltaY>0?1:-1); setTimeout(function(){ wl=false; },600); }, { passive:false });
        show.addEventListener('click', function(e){ if(!window.matchMedia('(min-width:901px)').matches) return; if(e.target===show || e.target.classList.contains('pdp-vshow__slide') || e.target.classList.contains('pdp-vshow__track') || e.target.classList.contains('pdp-vshow__frame')) fecharShow(); });
        show.classList.add('is-open');
        document.documentElement.classList.add('pdp-reels-lock'); document.body.classList.add('pdp-reels-lock');
        sHintLock=true;
        var st=Math.max(0, Math.min(start||0, lista.length-1));
        requestAnimationFrame(function(){ if(sTrack) sTrack.scrollLeft=st*sTrack.clientWidth; ativarShow(st); setTimeout(function(){ sHintLock=false; },450); });
      }
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && show && show.classList.contains('is-open')) fecharShow(); });

      for(var i = 0; i < vids.length; i++){
        (function(vid){
          if(vid.dataset.vplayPronto) return;
          vid.dataset.vplayPronto = '1';

          if(vid.dataset.poster){
            if(poObs) poObs.observe(vid);
            else vid.poster = vid.dataset.poster;  /* navegador sem IO: aplica direto */
          }

          /* A classe .is-playing (que revela o vídeo sobre o poster) vive no container.
             Nos vídeos que antes tinham autoplay, o data-lazyvid está no próprio <video>. */
          var box = vid.closest('[data-lazyvid]');
          if(!box || box === vid) box = vid.parentElement;
          if(!box) return;
          if(getComputedStyle(box).position === 'static') box.style.position = 'relative';

          /* ===== VÍDEOS "SHOWCASE" (Will 23/Jul): "O melhor acabamento do mercado" (.pdp-craft__video)
             e "Três acabamentos, um quadro impecável" (.pdp-acb-media). Dois comportamentos:
             (1) AUTOPLAY ao chegar perto da tela — o MP4 só baixa nesse momento (lazy, mesma técnica
                 do hero; pula reduce-motion/economia de dados/2G), SEM botão de play;
             (2) CLIQUE dá ZOOM — abre o vídeo grande no lightbox, igual os "quadros de clientes". */
          var ehShowcase = vid.classList.contains('pdp-craft__video') || !!vid.closest('.pdp-acb-media');
          if(ehShowcase){
            vid.addEventListener('playing', function(){ box.classList.add('is-playing'); });
            box.style.cursor = 'zoom-in';
            box.addEventListener('click', function(e){
              e.preventDefault();
              /* abre o player com TODOS os vídeos da MESMA seção, começando no que foi clicado */
              var sel = vid.classList.contains('pdp-craft__video') ? '.pdp-craft__video' : '.pdp-acb-media video';
              var grupo = [].slice.call(document.querySelectorAll(sel));
              var lista = grupo.map(function(g){
                var card = g.closest('.pdp-craft__item') || g.closest('.pdp-acb-card');
                var titEl = card && (card.querySelector('.pdp-craft__title') || card.querySelector('.pdp-acb-name'));
                var subEl = card && (card.querySelector('.pdp-craft__eyebrow') || card.querySelector('.pdp-acb-tag'));
                return { src: g.currentSrc || g.getAttribute('src') || g.getAttribute('data-src'), poster: g.dataset.poster,
                  title: titEl ? titEl.textContent.trim() : '', sub: subEl ? subEl.textContent.trim() : '' };
              });
              var idx = grupo.indexOf(vid);
              abrirShow(lista, idx < 0 ? 0 : idx);
            });
            var _rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var _c = navigator.connection;
            if(_rm || (_c && (_c.saveData || /(^|-)2g$/.test(_c.effectiveType||'')))) return;
            var tocar = function(){
              if(!vid.src && vid.getAttribute('data-src')){ vid.src = vid.getAttribute('data-src'); vid.load(); }
              var pp = vid.play(); if(pp && pp.catch) pp.catch(function(){});
            };
            if('IntersectionObserver' in window){
              var aObs = new IntersectionObserver(function(ents){
                ents.forEach(function(en){ if(en.isIntersecting){ tocar(); aObs.unobserve(vid); } });
              }, { rootMargin: '200px 0px' });
              aObs.observe(vid);
            } else { tocar(); }
            return;
          }

          var botao = document.createElement('button');
          botao.type = 'button';
          botao.className = 'pdp-vplay';
          botao.setAttribute('aria-label', 'Assistir ao vídeo');
          botao.innerHTML = ICONE_PLAY;
          box.appendChild(botao);

          botao.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(vid.dataset.poster && !vid.poster){ vid.poster = vid.dataset.poster; }  /* garantia se o IO ainda não passou */
            if(!vid.src){ vid.src = vid.getAttribute('data-src'); vid.load(); }  /* só AQUI baixa */
            var p = vid.play();
            if(p && p.catch) p.catch(function(){ botao.hidden = false; });
            botao.hidden = true;
          });

          /* tocar de novo no vídeo pausa e devolve o botão */
          vid.addEventListener('click', function(){
            if(!vid.paused){ vid.pause(); }
          });
          vid.addEventListener('playing', function(){ box.classList.add('is-playing'); botao.hidden = true; });
          vid.addEventListener('pause', function(){ botao.hidden = false; });
        })(vids[i]);
      }
    }
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarVideos);
    else iniciarVideos();
  })();

/* ═══ Foto ampliada da PDP (celular) ═══
   Decisões, para quem for mexer depois:
   · Baymard: suportar pinch E duplo toque — não há convenção única, só um gesto exclui metade.
   · O zoom NÃO fica na foto inline: o carrossel é scroll nativo e os gestos brigariam.
   · A lista de fotos é colhida NA HORA de abrir (colheFotos): selecionar moldura/tamanho TROCA
     o slide 1 pela foto da variante — o Will quer ampliar exatamente a foto que está na tela.
     Lista congelada no carregamento ampliava a foto antiga (bug da 1ª versão).
   · ⛔ As MINIATURAS de moldura/tamanho não abrem zoom nenhum (2ª rodada do Will): o toque
     nelas só seleciona; quem amplia é a IMAGEM PRINCIPAL, já trocada pela variante.
   · Fechar tem 3 saídas (X, arrastar pra baixo, voltar do Android). */
(function () {
  var dlg = document.getElementById('pdp-zoom');
  if (!dlg || !dlg.showModal) return;                 /* sem <dialog>, fica sem zoom (degrada) */
  var palco = dlg.querySelector('[data-pdpz-palco]');
  var img   = dlg.querySelector('[data-pdpz-img]');
  var conta = dlg.querySelector('[data-pdpz-conta]');
  var dica  = dlg.querySelector('[data-pdpz-dica]');
  var carrossel = document.getElementById('pdp-carousel');
  var stage = document.querySelector('.pdp__media-stage');
  if (!palco || !img || !stage) return;

  var fotos = [];
  function colheFotos() {
    fotos = [];
    var els = carrossel ? carrossel.querySelectorAll('img') : [];
    for (var i = 0; i < els.length; i++) {
      var u = els[i].getAttribute('src') || els[i].currentSrc || '';
      if (!u) continue;
      /* em alta: zoom em imagem pequena é pior que não ter zoom */
      if (/[?&]width=\d+/.test(u)) u = u.replace(/([?&])width=\d+/, '$1width=2048');
      else u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=2048';
      fotos.push(u);
    }
  }

  var idx = 0, escala = 1, x = 0, y = 0, aberto = false, empurrouEstado = false;
  var MAXZ = 4, YSCROLL = 0;

  function aplica(anim) {
    dlg.classList.toggle('is-animando', !!anim);
    img.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + escala + ')';
    if (anim) setTimeout(function () { dlg.classList.remove('is-animando'); }, 240);
  }
  function limites() {
    var lw = (img.offsetWidth * escala - window.innerWidth) / 2;
    var lh = (img.offsetHeight * escala - window.innerHeight) / 2;
    x = Math.max(-Math.max(lw, 0), Math.min(Math.max(lw, 0), x));
    y = Math.max(-Math.max(lh, 0), Math.min(Math.max(lh, 0), y));
  }
  function zera(anim) { escala = 1; x = 0; y = 0; aplica(anim); }

  function mostra(i, anim) {
    idx = (i + fotos.length) % fotos.length;
    img.src = fotos[idx];
    if (conta) conta.textContent = (idx + 1) + '/' + fotos.length;
    zera(anim);
    /* vizinhas prontas: trocar de foto ampliada não pode piscar */
    [idx - 1, idx + 1].forEach(function (k) {
      var f = fotos[(k + fotos.length) % fotos.length];
      if (f) { var p = new Image(); p.decoding = 'async'; p.src = f; }
    });
  }

  /* ── trava de rolagem à prova de iOS: overflow:hidden no body não segura lá ── */
  function trava() {
    YSCROLL = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-YSCROLL) + 'px';
    document.body.style.width = '100%';
  }
  function destrava() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, YSCROLL);
  }

  function abrir(i) {
    if (aberto) return;
    colheFotos();                                       /* a foto da VARIANTE entra aqui */
    if (!fotos.length) return;
    aberto = true;
    trava();
    dlg.showModal();
    mostra(i, false);
    /* o VOLTAR do Android tem de fechar a foto, não sair da página */
    try { history.pushState({ pdpz: 1 }, ''); empurrouEstado = true; } catch (e) {}
    try {
      if (dica && !sessionStorage.getItem('pdpz_dica')) {
        dica.classList.add('on');
        sessionStorage.setItem('pdpz_dica', '1');
        setTimeout(function () { dica.classList.remove('on'); }, 3200);
      }
    } catch (e) {}
  }
  function fechar(peloHistorico) {
    if (!aberto) return;
    aberto = false;
    dlg.close();
    destrava();
    /* devolve o carrossel na MESMA foto em que a pessoa estava ampliando */
    if (carrossel && carrossel.children[idx]) {
      carrossel.scrollTo({ left: carrossel.children[idx].offsetLeft, behavior: 'auto' });
    }
    if (!peloHistorico && empurrouEstado) { empurrouEstado = false; try { history.back(); } catch (e) {} }
  }
  window.addEventListener('popstate', function () { if (aberto) { empurrouEstado = false; fechar(true); } });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); fechar(false); });   /* Esc */
  dlg.querySelector('[data-pdpz-close]').addEventListener('click', function () { fechar(false); });

  /* ── abrir: toque na foto que NÃO tenha virado arrasto do carrossel ── */
  function idxAtual() {
    return (carrossel && carrossel.clientWidth) ? Math.round(carrossel.scrollLeft / carrossel.clientWidth) : 0;
  }
  var tx = 0, ty = 0, arrastou = false;
  stage.addEventListener('pointerdown', function (e) { tx = e.clientX; ty = e.clientY; arrastou = false; }, { passive: true });
  stage.addEventListener('pointermove', function (e) {
    if (Math.abs(e.clientX - tx) > 8 || Math.abs(e.clientY - ty) > 8) arrastou = true;
  }, { passive: true });
  stage.addEventListener('click', function (e) {
    if (arrastou) return;
    if (e.target.closest('a,button,[role="button"]')) return;   /* setas, coração, carrinho */
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;  /* desktop tem hover-zoom */
    e.preventDefault();
    abrir(idxAtual());
  });
  var lupa = document.querySelector('.pdp__lupa');
  if (lupa) lupa.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    abrir(idxAtual());
  });

  /* ── gestos dentro do lightbox ── */
  var pts = new Map(), base = 0, escBase = 1, xBase = 0, yBase = 0, meio = null;
  var toqueT = 0, toqueX = 0, toqueY = 0, movendo = false, fechandoY = 0;

  palco.addEventListener('pointerdown', function (e) {
    /* setPointerCapture lança NotFoundError se o ponteiro já não estiver ativo (gesto muito
       rápido/sintético). Sem o try, a exceção aborta o handler e o gesto morre em silêncio. */
    try { palco.setPointerCapture(e.pointerId); } catch (err) {}
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    movendo = false;
    if (pts.size === 2) {
      var a = [...pts.values()];
      base = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
      escBase = escala; xBase = x; yBase = y;
      meio = { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 };
    } else { xBase = x; yBase = y; fechandoY = 0; }
  });

  palco.addEventListener('pointermove', function (e) {
    if (!pts.has(e.pointerId)) return;
    var ini = pts.get(e.pointerId);
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY, ix: ini.ix != null ? ini.ix : ini.x, iy: ini.iy != null ? ini.iy : ini.y });

    if (pts.size === 2 && base) {                       /* PINCH */
      var a = [...pts.values()];
      var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
      var nova = Math.max(1, Math.min(MAXZ, escBase * (d / base)));
      var f = nova / escBase;
      /* âncora relativa ao CENTRO da tela — é onde fica o centro da imagem em repouso
         (origin center + flex center). Coordenada absoluta aqui desloca o ponto ancorado. */
      var mx = meio.x - window.innerWidth / 2, my = meio.y - window.innerHeight / 2;
      x = mx - (mx - xBase) * f;
      y = my - (my - yBase) * f;
      escala = nova;
      limites(); aplica(false);
      movendo = true;
      return;
    }

    var p = [...pts.values()][0];
    var dx = p.x - (p.ix != null ? p.ix : p.x), dy = p.y - (p.iy != null ? p.iy : p.y);
    if (escala > 1.02) {                                /* PAN na foto ampliada */
      x = xBase + dx; y = yBase + dy; limites(); aplica(false); movendo = true;
    } else {                                            /* 1×: lateral troca foto, baixo fecha */
      if (Math.abs(dy) > Math.abs(dx) && dy > 0) {
        fechandoY = dy; movendo = true;
        img.style.transform = 'translate3d(0,' + dy + 'px,0) scale(' + Math.max(.86, 1 - dy / 900) + ')';
        dlg.style.opacity = String(Math.max(.35, 1 - dy / 500));
      } else if (Math.abs(dx) > 12) { movendo = true; }
    }
  });

  function solta(e) {
    if (!pts.has(e.pointerId)) return;
    var p = pts.get(e.pointerId);
    var dx = p.x - (p.ix != null ? p.ix : p.x);
    pts.delete(e.pointerId);
    if (pts.size < 2) { base = 0; meio = null; }
    if (pts.size > 0) return;

    dlg.style.opacity = '';
    if (fechandoY > 100) { img.style.transform = ''; fechar(false); fechandoY = 0; return; }
    if (fechandoY) { fechandoY = 0; zera(true); return; }

    if (escala <= 1.02 && Math.abs(dx) > 55) { mostra(idx + (dx < 0 ? 1 : -1), false); return; }
    if (escala <= 1.02) zera(true); else { limites(); aplica(true); }

    if (!movendo) {                                     /* toque limpo → duplo toque? */
      var agora = Date.now();
      if (agora - toqueT < 300 && Math.abs(p.x - toqueX) < 30 && Math.abs(p.y - toqueY) < 30) {
        toqueT = 0;
        if (escala > 1.02) { zera(true); }
        else {
          escala = 2.5;
          x = (window.innerWidth / 2 - p.x) * (escala - 1);
          y = (window.innerHeight / 2 - p.y) * (escala - 1);
          limites(); aplica(true);
        }
      } else { toqueT = agora; toqueX = p.x; toqueY = p.y; }
    }
  }
  palco.addEventListener('pointerup', solta);
  palco.addEventListener('pointercancel', function (e) { pts.delete(e.pointerId); base = 0; dlg.style.opacity = ''; });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porao-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var filtersEl = document.getElementById('rv-filters');
  var reviewList = document.getElementById('rv-list');
  var showMoreBtn = document.getElementById('rv-show-more');
  var listExpanded = false;

  function setListExpanded(exp) {
    listExpanded = exp;
    /* O `hidden` vem do servidor (lista nasce fechada, sem flash). Aqui só alterna — usando
       o atributo, não style.display, pra não brigar com o `hidden` do HTML. */
    if (reviewList) { reviewList.hidden = !exp; reviewList.style.display = exp ? '' : 'none'; }
    if (showMoreBtn) showMoreBtn.textContent = exp ? 'Recolher avaliações' : 'Ver todas as avaliações';
    if (showMoreBtn) showMoreBtn.classList.toggle('rv__show-more--open', exp);
  }

  // Avaliações individuais RECOLHIDAS por padrão — página mais leve
  /* bugfix 28/08: sincroniza com o DOM em vez de forçar false — o botão inline pode já
     ter aberto a lista na janela do defer, e o false incondicional a fechava sob o dedo. */
  if (reviewList) setListExpanded(!reviewList.hidden);

  // Botão Ver todas / Recolher (toggle)
  if (showMoreBtn && reviewList && !showMoreBtn.hasAttribute('data-rv-wired')) {
    showMoreBtn.addEventListener('click', function() {
      var next = reviewList.hidden; /* bugfix 28/08: fonte de verdade = DOM, não a variável */
      setListExpanded(next);
      if (!next) {
        var sec = document.getElementById('reviews');
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Filtros — clicar num filtro expande a lista e aplica o filtro
  if (filtersEl) {
    filtersEl.addEventListener('click', function(e) {
      var tag = e.target.closest('.rv__filter-tag');
      if (!tag) return;
      filtersEl.querySelectorAll('.rv__filter-tag').forEach(function(t) {
        t.classList.remove('rv__filter-tag--active');
      });
      tag.classList.add('rv__filter-tag--active');

      /* bugfix 28/08: decide pelo DOM — listExpanded dessincronizava quando o "Recolher"
         inline fechava a lista, e o filtro ativava o chip sem reabrir nada. */
      if (reviewList && reviewList.hidden) setListExpanded(true);

      var filter = tag.dataset.filter;
      var items = document.querySelectorAll('.rv__item');
      items.forEach(function(item) {
        if (filter === 'all') {
          item.style.display = '';
        } else if (filter === 'photo') {
          item.style.display = item.dataset.hasPhoto === 'true' ? '' : 'none';
        } else {
          item.style.display = item.dataset.stars === filter ? '' : 'none';
        }
      });
    });
  }

  // Helpful buttons
  if (reviewList) {
    reviewList.addEventListener('click', function(e) {
      var btn = e.target.closest('.rv__helpful-btn');
      if (!btn) return;
      if (btn.classList.contains('rv__helpful-btn--active')) return;
      btn.classList.add('rv__helpful-btn--active');
      var countEl = btn.querySelector('.rv__helpful-count');
      if (countEl) {
        countEl.textContent = parseInt(countEl.textContent) + 1;
      }
    });
  }

  // Lightbox — open on photo click
  var lightbox = document.getElementById('rv-lightbox');
  var lightboxImg = document.getElementById('rv-lightbox-img');
  var lightboxClose = document.getElementById('rv-lightbox-close');
  /* bugfix 28/08: mesma função do engate inline (trava html E body) — o Esc limpava só
     o body e o overflow:hidden do <html> ficava, travando o scroll da página. */
  var rvScroll = window.__rvScroll || function (lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  };

  document.addEventListener('click', function(e) {
    var photoEl = e.target.closest('.rv__item-photo, .rv__photo-thumb');
    if (!photoEl || !lightbox || !lightboxImg) return;
    var img = photoEl.querySelector('img');
    if (!img) return;
    /* O thumb vem do CDN com width=280/320. Copiar esse src pro lightbox (que abre a até
       90vw) mostrava a foto do cliente ampliada 3-4x, borrada, justo no momento em que a
       pessoa está inspecionando a prova social. Pede a versão grande ao CDN. */
    lightboxImg.src = img.src.replace(/([?&]width=)\d+/, '$1' + 1600);
    lightboxImg.alt = img.alt;
    lightbox.hidden = false;
    rvScroll(true); /* bugfix 28/08: trava html E body */
  });

  if (lightbox && lightboxClose) {
    function closeLightbox() {
      lightbox.hidden = true;
      rvScroll(false); /* bugfix 28/08: destrava html E body (Esc passa por aqui) */
    }
    lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
